export const en = {
  translation: {
    analytics: {
      title: 'Analytics',
      period: 'Period:',
      selectPeriod: 'Select Period',
      qrCode: 'QR Code:',
      selectQrCode: 'Select QR Code',
      operatingSystem: 'Operating system:',
      selectOperatingSystem: 'Select Operating system',
      countries: 'Countries:',
      selectCountries: 'Select countries',
      cities: 'Cities:',
      selectCities: 'Select cities',
      totalQrCodes: 'Total QR Codes',
      totalScans: 'Total Scans',
      totalUniqueScans: 'Total Unique Scans',
      totalUniqueScansTooltip:
        '"Total Unique Scans" refers to the distinct number of users who have performed at least one scan within the chosen timeframe, counting each user only once.',
      totalVisits: 'Total visits',
      qrCodeScanActivities: 'QR Code Scan Activities',
      analyzedPeriod: 'Analyzed period:',
      noDataStatistics: 'Not enough data to show statistics.',
      scansByOperatingSystems: 'Scans by operating systems',
      scansByCountry: 'Scans by country',
      scansByRegionCity: 'Scans by region / city',
      reportsNotRealTime: 'Reports are not generated in real time, they can have a delay of up to 5 minutes.',
      tooltipCountry: 'We use Maxmind for IP geolocation. Accuracy varies based on server location and VPN usage.',
      tooltipCity: 'We use Maxmind for IP geolocation. Accuracy varies based on server location and VPN usage.',
      periodOptions: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7days: 'Last 7 days',
        last30days: 'Last 30 days',
        last90days: 'Last 90 days',
        lifetime: 'Lifetime',
        custom: 'Custom',
      },
      qrCodeOptions: {
        all: 'All',
        myBirthday: 'My Birthday',
        myWebsite: 'My Website',
      },
      operatingSystemOptions: {
        all: 'All',
        android: 'Android',
        ios: 'IOS',
      },
      countriesOptions: {
        all: 'All',
        thailand: 'Thailand',
        usa: 'USA',
      },
      citiesOptions: {
        all: 'All',
        newYork: 'New York',
        toronto: 'Toronto',
      },
    },
    alerts: {
      instructionsForQRCodePreview: 'Complete the data and you will be able to preview your QR code',
      login: 'Error! The server is not responding. Contact your service provider.',
      nif_info: 'To issue a valid invoice, it is necessary to indicate your tax ID, for example, ES12345678',
      timeRemaining: 'days remaining',
      socialError: 'An error occurred! The login form either contains an error or was closed!',
      subscriptionExpired: 'Free trial ended',
      editType: 'Changing the QR type will delete the current data.',
      successCopiedToClipboard: 'Text copied to clipboard',
    },
    buttons: {
      addNew: 'Add new',
      forDev: 'Developers',
      supp: 'Support',
      upgradeNow: 'Upgrade Now',
      detail: 'Detail',
      edit: 'Edit',
      download: 'Download',
      back: 'Back',
      upload: 'Upload file',
      delete: 'Delete',
      deleteQRcode: 'Delete QR Code',
      addLink: 'Add link',
      addCoverLogo: 'Add cover image',
      addImage: 'Add image',
      logOutBtn: 'Log out',
      addLogo: 'Add your logo',
      preview: 'Preview',
      qrCode: 'QR code',
      pause: 'Pause',
      start: 'Start',
      planPrice: 'Plans and prices',
      faq: 'FAQ',
      home: 'Home',
      api: 'API',
      resources: 'Resources',
      login: 'Log In',
      signUp: 'Sign Up',
      loginCreate: 'Login to Create',
      downloadQr: 'Download QR',
      activate: 'Activate',
      cancel: 'Cancel',
      close: 'Close',
      proceed: 'Proceed',
      deletePermanently: 'Delete permanently',
      exit: 'Close',
      createQrCode: 'Create qr code',
      activateAccount: 'Activate Account',
      create: 'Create',
      save: 'Save',
      active: 'Active',
      saveTo: 'Save to',
      submit: 'Submit',
    },
    general: {
      complete: 'Complete',
      qrCodePreviewTitle: 'Scan me!',
      qrCoderPreviewText: `IMPORTANT: Don't forget to test your QR code`,
      important: 'Important',
      readabilityQr:
        'The readability of this QR code design may not be ideal. We suggest testing the QR code by scanning it to confirm it functions properly.',
    },
    socialButtons: {
      googlePlayText: 'GET IT ON',
      googlePlayTitle: 'Google Play',
      appleText: 'Download on the',
      appleTitle: 'App Store',
    },
    errors: {
      invalidHexCode: 'The color is invalid',
      maxLength: 'Max length is 2000 symbols',
      scanMinNumber: 'Scan limit must be at least 1',
      scan_limit: 'Must be less than or equal to 10000000',
      url_1: 'URL must start with http:// or https://',
      url_2: 'URL must be valid',
      emailIsValid: 'Email not valid.',
      phoneCode: 'Invalid area code',
      phoneIsValid: 'Invalid phone number',
      url: 'URL must start with http:// or https://',
      max: 'Max length is {{count}} symbols',
    },
    inputs: {
      required: 'Required field',
    },
    titles: {
      socialMediaMicroSiteTitle: 'Find me on:',
      link: 'Link',
    },
    labels: {
      selected: 'Selected',
      noTracking: 'No Tracking',
      headerTitle: 'Base Title Example',
      myQrTitle: 'My QR codes',
      all: 'All',
      static: 'Static',
      dynamic: 'Dynamic',
      info: 'Info',
      url: 'URL',
      linkText: 'Link text',
      metrics: 'Metrics',
      action: 'Action',
      createTime: 'Created: {{time}}',
      scans: 'Scans',
      staticTootip: 'This QR is static and does not allow tracking, so there will be no record of scans.',
      website: 'Website',
      defaultTrialWarningMessage:
        'Your free trial will end on {{endTime}}, after that date your QR codes will be deactivated.',
      defaultPlanErrorMessage: 'Your subscription has expired. Functionality is limited until payment is made.',
      pauseQrCodeNotification:
        'Please note that the availability of this QR code has been paused. To continue its availability, please activate it again.',
      dragAndDrop1: 'Click to upload',
      dragAndDrop2: 'or drag and drop',
      addMore: 'Add more',
      max: 'max',
      name: 'Name',
      description: 'Description',
      text: 'Text',
      textColor: 'Text color',
      https: 'https://',
      paused: 'Paused',
      scanLimit: 'Scan limit',
    },
    placeholders: {
      default: 'Placeholder',
    },
    qrDetail: {
      media: 'Media',
      print: 'Print',
      totalScan: 'Total Scans',
      titleScanAtivity: 'Scan Activity',
      titleScanOC: 'Scans by operating system',
      oc: 'Operating system',
      titleScanCountry: 'Scans by country',
      country: 'Country',
      region: 'Region',
      browser: 'Browser',
      titleScanRegion: 'Scans by region/city',
      titleScanBrowser: 'Scans by browser',
      titleScanLang: 'Scans by user language',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      lastHours: 'Today',
      lastDays: 'Current Month',
      lastMonth: 'Current Year',
      total: 'Total',
      unique: 'Unique',
      visits: 'Visit to preview',
    },
    other: {
      selectedItems: 'items selected',
      months: 'months',
      rowsPerPage: 'Rows per page:',
      maxLength: 'Max length is {{maxLength}} symbols',
      title: 'Title',
      text: 'Text',
      titleColor: 'Title color',
      textsColor: 'Texts color',
      company: 'Company',
      description: 'Description',
      website: 'Website',
      button: 'Button',
      default: 'Default',
      template: 'Template {{templateId}}',
      vertical: 'Vertical',
      horizontal: 'Horizontal',
      grid: 'Grid {{gridId}}',
      phone: 'Phone',
      name: 'Name',
      profession: 'Profession',
      location: 'Location',
      email: 'Email',
      imageAlbum: 'Image / photo / album title',
      btnTxt: 'Button text',
      images: 'PNG, JPEG',
      showLink: 'Show address link',
      hideLink: 'Hide address link',
      showMap: 'Show the map',
      surname: 'Surname',
      appName: 'App name',
      developerCompany: 'Developer/Company',
      titlePosition: 'Title position',
      label: 'Label',
      processing: 'Files are processing...',
      address: 'Address',
      subject: 'Subject',
      message: 'Message',
    },
    thirdStep: {
      designQr: 'Design the QR',
      frame: 'Frame',
      frameColour: 'Frame color',
      useGradients: 'Use gradients?',
      bgColor: 'Background color',
      transparentBg: 'Transparent background',
      qrCodeStyle: 'QR code style',
      qrText:
        'Remember! For the optimal reading of the QR code, you need to use high contrast colors. We recommend selecting a light and a dark color for your QR code.',
      shape: 'Shape',
      corners: 'Corners',
      borderStyle: 'Border style',
      centerStyle: 'Center style',
      cornerBorderColour: 'Corner border color',
      cornerCenterColour: 'Corner center color',
      correctionLevel: 'Correction level',
      addLogo: 'Add logo',
      gradientType: 'Gradient type',
      level: 'Level',
      uploadLogo: 'Upload your logo',
      selectLogo: 'Select logo',
      color: 'Color',
    },
    sidebar: {
      newQr: 'Create QR Code',
      analytics: 'Analytics',
      myQRCodes: 'My QR Codes',
      myAccount: 'My Account',
      payments: 'Billing',
      hideSidebar: 'Hide sidebar',
    },
    login: {
      welcome: 'Welcome!',
      text: 'Enter with your networks or complete your email to work with QRs',
      googleButton: 'Sign in with Google',
      facebookButton: 'Sign in with Facebook',
      googleButtonSignUp: 'Sign up with Google',
      facebookButtonSignUp: 'Sign up with Facebook',
      emailInput: 'Email address',
      emailLogin: 'LOG IN',
      emailLoginSignUp: 'SIGN UP',
      popuph1: 'Last step',
      popuph2: 'Sign up to save and manage your QR codes.',
      confirmationh2: 'We have just sent you a confirmation link to your email,',
      confirmationh3: 'just click on it and you will be logged in.',
      createAccount: 'Create account',
      createTitle: 'Enter your email to finalize account creation',
      bottomTitle: 'By creating an account, you consent',
      bottomTitle1: 'that you have read and agree to our',
      bottomTitle2: 'Terms of Service.',
    },
    signIn: {
      title: 'Welcome Back!',
      subtitle: 'Sign in with Google or use your email',
      dividerText: 'Or, log in with email',
      registerLink: 'Don`t have an account? <1>Create an account</1>',
      inputs: {
        email: {
          placeholder: 'Enter your email...',
        },
      },
      buttons: {
        signInWithGoogle: 'Sign in with Google',
        login: 'Log In',
      },
      loginGoogle: 'Or, log in with Google',
    },
    signUp: {
      title: 'Sign up',
      subtitle: 'Create a free account',
      dividerText: 'Or, sign up with email',
      loginLink: 'Already have an account? <1>Log In</1>',
      byCreatingAccountYouAgree:
        'By creating an account, you consent that you have read and agree to our <1>Terms & Conditions</1> and the <2>Privacy Policy</2>.',
      inputs: {
        email: {
          placeholder: 'Enter your email...',
        },
      },
      buttons: {
        signUpWithGoogle: 'Sign up with Google',
        signUp: 'Sign Up',
      },
      slides: {
        0: {
          title: 'Choose Your QR Code Content',
          desc: 'Choose Your QR Create QR codes for anything—websites, PDFs, images, links, vCards, and more. Tailor it to fit your needs.',
        },
        1: {
          title: 'Customize and design QR-code',
          desc: 'Add your details and use our generator to craft a QR code that’s uniquely yours.',
        },
        2: {
          title: 'Download your code and share it',
          desc: 'Create QR codes for anything—websites, PDFs, images, links, vCards, and more. Tailor it to fit your needs.',
        },
      },
      google: 'Or, sign up with Google',
    },
    confirmation: {
      p1: 'Please check your email',
      p2: 'We have just sent you a confirmation link.',
      p3: 'Click on the link and you will be logged in.',
      p4: 'Did you make a mistake when entering data?',
      p5: 'Do not receive the email?',
      p6: 'Try waiting a couple of minutes or',
      p6_end_text: 'Contact support',
      btnText: 'Change email',
    },
    createQrStep1: {
      created: 'Created',
      p1: 'Select QR type',
      p2: 'Add content',
      p3: 'QR Code design',
      btn1: 'Back',
      btn2: 'Next',
      btn3: 'Complete',
      h1: 'Dynamic QR',
      h2: 'Update content in real time, without changing your code.',
      h3: 'Static QR',
      label1: 'With Tracking',
      label2: 'No Tracking',
      label3: 'Draft',
      staticDescription: 'Reprint required when updating content.',
      items: {
        b1: { name: 'Website', subName: 'Open a URL' },
        b2: { name: 'PDF', subName: 'Show a PDF' },
        b3: { name: 'List of links', subName: 'Group links' },
        b4: { name: 'Apps', subName: 'Redirect to an app store' },
        b5: { name: 'Images', subName: 'Show an image gallery' },
        b6: { name: 'vCard Plus', subName: 'Share contact details' },
        b7: { name: 'Social media', subName: 'A tree for your all social' },
        b8: { name: 'Coupon', subName: 'Share a coupon' },
        b9: { name: 'Video', subName: 'Show a video' },
        c1: { name: 'URL', subName: 'Open a URL' },
        c2: { name: 'Text', subName: 'Display plain text' },
        c3: { name: 'Wi-Fi', subName: 'Connect to a Wi-Fi network' },
        c4: { name: 'Email', subName: 'Send an email with predefined text' },
        c5: { name: 'vCard', subName: 'Share and store your contact details' },
        c6: { name: 'SMS', subName: 'Send a text message' },
        c7: { name: 'Whatsapp', subName: 'Sand a Whatsapp message' },
      },
      previewTitle: 'Example',
      preview: 'Preview',
      alertClose: 'Got it',
      rememberAboutPreview: 'Remember that you can preview and test your QR codes by clicking on the “QR code” button.',
    },
    editor: {
      headerTitle: 'Complete the content of the QR',
      headerInputPlaceholder: 'Name of your QR code...',
    },
    basicTemplateLabels: {
      //Titles block
      appearanceTitle: 'Appearance',
      appearanceSubTitle: 'Customize the style and template.',
      basicInfoTitle: 'Basic information',
      basicInfoSubTitle: 'Add essential information',
      contentTitle: 'Content',
      contentSubTitle: 'All the details about your QR',
      statsTitle: 'Stats',
      statsSubTitle: 'Key tools and data to evaluate performance',
      //Titles section
      tmplPreview: 'Select template',
      tmplDesign: 'Design',
      tmplFonts: 'Fonts',
      socilaNet: 'Social networks',
      //preview titles
      websiteTitle: 'QR code generator',
      settings: 'Advanced Settings',
      nameAndOrganisation: {
        title: 'Name & Organisation',
        description: 'Name your QR code and organize it in folders.',
        name: 'Name',
        namePlaceholder: 'E.g. My QR Code',
      },

      passwordProtection: {
        title: 'Password Protection',
        description: 'Add password protection',
        switchLabel: 'Activate password to access the QR code.',
        inputLabel: 'Password',
        inputPlaceholder: 'Enter your password...',
        modalTitle: 'Enter Password',
        modalDesc: 'If you want to access this QR, you need to obtain the appropriate password.',
      },
    },
    template0: {
      title1: 'Basic information',
      subTitle1: 'Add essential information',
      title2: 'Website information',
      label1: 'Website URL',
      placeholder1: 'E.g. https://langding-page.com/',
      title3: 'Stats',
      subTitle2: 'Key tools and data to evaluate performance',
      title4: 'URL configuration',
      subTitle3: 'Customize your qr-gen.me address identifier',
      sliderTitle1: 'Auto Generate',
      placeholder2: 'https://qr-gen.me/p/auto-generated',
      notification:
        'Changes to the short URL of an already published QR code will cause the previous version of the QR code to be overwritten and it will no longer be scannable. It will be necessary to print the QR code again.',
      title5: 'Scan limits',
      subTitle4: 'Limit the number of times your QR can be scanned in total',
      sliderTitle2: 'Enable scan limit',
    },
    template1: {
      uploader: 'File upload',
      uploaderDesc: 'Directly show the PDF file',
      pdfInfo: 'PDF information',
      primary: 'Primary',
      secondary: 'Secondary',
      bg: 'Background',
      bgLink: 'Background of the link',
      colorLink: 'Link text color',
      error: 'It must have at least 1 element(s)',
    },
    template2: {
      titleSize: 'Title size',
      descriptionSize: 'Description size',
      socialSize: 'Social media size',
      titleLink: 'Link list information',
      titleContent: 'Content',
      subTitleContent: 'All the details about your QR',
      seconTitleLink: 'Link',
      links: 'Links',
      linkText: 'Link text',
      writeHere: 'Write here the link text',
      titleImages: 'Images',
    },
    template3: {
      appInfo: 'App information',
      addLogo: 'Add your logo',
    },
    template5: {
      about: 'About you',
      constactInfo: 'Contact info',
      location: 'Location',
      locationOpt: 'Location options',
      complete: 'Complete',
      url: 'URL',
      coordinate: 'Coordinates',
      addPhone: 'Add phone',
      addEmail: 'Add email',
      addWeb: 'Add website',
      addCompany: 'Add Company',
      image: 'Image',
      companies: 'Companies',
      custBtnText: 'Customize your buttons',
      custBtnTextSub: 'Edit the texts of the shortcuts',
      header: 'Header',
      footer: 'Footer',
      contactStore: 'Contacts storage options',
      contactTopLabel: `"Add contact" on the top`,
      floatingLabel: 'Floating button',
      titleOnly: 'Title only',
      orgOnly: 'Organization only',
      orgAndTitle: 'Organization and title',
      summary: 'Summary',
      manual: 'Manual Entry',
      delete_address: 'Delete address',
      latitude: 'Latitude',
      longitude: 'Longitude',
      downloadQr: 'Download qr',
      street: 'Street',
      strNumber: 'Number',
      postCode: 'Postal Code',
      city: 'City',
      state: 'State / Province',
      country: 'Country',
      titlePosition: {
        left: 'Left',
        right: 'Right',
        center: 'Center',
      },
      phoneType: {
        mobile: 'Mobile',
        work: 'Work',
        home: 'Home',
        fax: 'Fax',
        other: 'Other',
      },
      showMap: 'Show on map',
      searchAddress: 'Search address',
      yourAvatar: 'Your avatar',
      coverImage: 'Cover image',
    },
    template6: {
      imageInfo: 'Image information',
      addBtn: 'Add Button',
      socialmedia: 'Social media information',
      placeholder: {
        p1: 'E.g. My photos',
        p2: 'E.g. Trips 2019',
        p3: 'E.g. https://mywebsite.com',
      },
    },
    staticQrTemplates: {
      wifi: {
        mockup: {
          title: 'Join the “Hotel Bar” Wi-fi network?',
          accept: 'Accept',
          cancel: 'Cancel',
        },
        content: {
          title: 'Wi-Fi information',
          fields: {
            ssid: {
              label: 'Network name (SSID)',
              placeholder: 'E.g. HomeWifi',
            },
            password: {
              label: 'Network password',
              placeholder: 'E.g. Mypassword',
            },
            authType: {
              label: 'Type of encryption',
            },
            hidden: {
              label: 'Hidden network',
            },
          },
        },
      },
      sms: {
        mockup: {
          number: 'Number',
          message: 'Message',
        },
        content: {
          title: 'SMS information',
          fields: {
            number: {
              label: 'Number',
              placeholder: 'Enter a number',
            },
            message: {
              label: 'Message',
              placeholder: 'Enter a message',
            },
          },
        },
      },
      whatsapp: {
        mockup: {
          number: 'Number',
          message: 'Message',
        },
        content: {
          title: 'Whatsapp information',
          fields: {
            number: {
              label: 'Number',
              placeholder: 'Enter a number',
              info: 'The number must have the country prefix',
            },
            message: {
              label: 'Message',
              placeholder: 'Enter a message',
            },
          },
        },
      },
      text: {
        content: {
          fields: {
            text: {
              title: 'Text',
              label: 'Message',
              placeholder: 'Enter some text...',
            },
          },
        },
      },
      email: {
        content: {
          title: 'Email information',
        },
      },
    },
    settings: {
      settingsTitle: 'My Account / Settings',
      tab1: 'General Information',
      tab2: 'Billing Information',
      saveBtn: 'Save',
      titleSection1: 'Contact information',
      titleSection3: 'Time Zone',
      titleSection5: 'Date and time',
      titleSection4: 'Account details',
      Language: 'Language',
      titleSection6: 'Thousands',
      subscribeTitle: 'Email preferences',
      subscribeDesc: 'Unsubscribe if you do not want to receive emails with important information about your account.',
      subscribeDesc2:
        'If you subscribe, you’ll receive emails with important updates and information about your account.',
      unsubBtn: 'Unsubscribe',
      subBtn: 'Subscribe',
      accTitle: 'Account status',
      accDesc:
        'You can delete your account if you are sure that our service will never be useful to you again. Your data will be permanently deleted.',
      deleteAccBtn: 'Delete account',
      hoursFormat: 'Hours format',
      dateFormat: 'Date format',
      individualBtn: 'Individual',
      companyBtn: 'Company name',
      optional: '(Optional)',
      country: 'Country',
      nif: 'Tax ID',
      name: 'Name',
      surname: 'Surname',
      adress: 'Address',
      city: 'City',
      postCode: 'Postal code',
      email: 'Email',
      phone: 'Phone',
      phoneCode: 'Code',
      placeholdPhoneCode: 'E.g. +44',
      placeholdCompany: 'E.g. My company',
      placeholdNIF: 'E.g. 43468392N',
      placeholdName: 'E.g. Mary',
      placeholdSurname: 'E.g. Smith',
      placeholdEmail: 'E.g. name@email.com',
      placeholdAddress: 'E.g. Main Street',
      placeholdCity: 'E.g. London',
      placeholdPost: 'E.g. 28028',
      informationUpdated: 'Information updated!',
      languageUpdated: 'Language updated!',
      timeUpdated: 'Time Zone updated!',
      dateUpdated: 'Date and Time updated!',
      thousandsUpdated: 'Thousands updated!',
    },
    supportModal: {
      title: 'Write us your query',
      inputLabel1: 'Reason*',
      inputLabel2: 'Label*',
      placeholder2: 'Write a subject',
      inputLabel3: 'Query*',
      cancelBtn: 'Cancel',
      sendBtn: 'Send',
    },
    downloadStep: {
      title: 'Last Step:',
      subtitle: 'Download the QR!',
    },
    downloadModal: {
      title: 'Save as...',
      jpeg: 'Standard image file.',
      png: 'File with transparent background.',
      svg: 'Vector file.',
      pdf: 'Universal file format.',
      eps: 'Editable vector file.',
    },
    upgradeModal: {
      logoText: 'Upgrade to continue using QRbrain.io',
      title: 'Reactivate today and stay in control',
      subTitle:
        'Get back full access to all features of your QR code management platform without interruptions. Reactivate now and enjoy:',
      listItem1: 'Restore all paused QR codes immediately.',
      listItem2: 'Generate and modify QR codes as needed.',
      listItem3: 'Monitor scans, engagement, and performance insights.',
      listItem4: 'Edit colors, logos, and designs to match your brand.',
      listItem5: 'Choose from multiple formats like URL, vCard, PDFs, and more',
      listItem6: 'Ensure your QR codes work without any scan limitations.',
      listItem7: 'Export QR codes in various high-quality formats.',
      listItem8: 'Get expert assistance whenever you need it.',
      listItem9: 'Cancel anytime.',
      buttonText: 'Upgrade My Account',
    },
    uploaderModal: {
      title: 'Upload photo',
      saveBtn: 'Save',
      zoom: 'Zoom',
      roundness: 'Roundness',
      rotateBtn: 'Rotate',
      resetBtn: 'Reset',
    },
    payments: {
      title: 'Plans and payments',
      bestValue: 'Best Choice',
      ourBenefits: 'Our Benefits',
      month: 'month',
      description: 'Subscribe to the plan that best suits your needs.',
      footerNote: 'Value Added Tax not included in the amounts.',
      buyBtn: 'Buy a subscription',
      mangeSubscription: 'Manage subscriptions',
      list: {
        a1: 'Create and update QR codes on the fly',
        a2: 'Track scans, engagement, and performance',
        a3: 'Customize colors, logos, and overall design',
        a4: 'Choose from multiple formats (URL, vCard, PDFs, etc.)',
        a5: 'No scan limits',
        a6: 'Export QR Codes in different high-quality formats',
        a7: 'Dedicated support',
        a8: 'Cancel anytime',
      },
      bestValue50: 'Best Value - Save 50%',
      save50PercentAnnually: 'Save 50% annually',
      savePercentAnnually: 'Save {{percentOff}}% annually',
      plansAdnServices: {
        plans: {
          title0: 'Create unlimited QRs',
          title1: 'Variety of QR types',
          title2: 'Variety of download formats',
          title3: 'Complete QR analytics',
          title4: 'Editing and management',
          title5: 'Unlimited scans',
          title6: 'Custom domain',
          subTitle0: 'Create unlimited QRs and update them whenever you want in real time.',
          subTitle1: 'Choose from multiple QR types, such as Websites, PDFs, Images and more.',
          subTitle2: 'Download your QR in PNG, SVG, PDF, among others.',
          subTitle3: 'Get statistics on the number of scans, locations and user devices.',
          subTitle4: 'Customize your QRs with colors, fonts, and the logo.',
          subTitle5: 'Your QRs can be scanned unlimited times.',
          subTitle6: 'Use your own domain to customize the URL of your QRs.',
        },
      },
    },
    checkout: {
      selectPlan: 'Select plan',
      summaryTitle: 'Summary',
      period: 'months',
      total: 'TOTAL',
      paymentSecure: 'SECURE PAYMENT',
      paymentMethods: 'Accepted payment methods',
      cancelBtn: 'Cancel',
      nextBtn: 'Next',
      successfullPayment: 'Payment Successful',
      successfullPaymentText: 'Now you can use the platform to conveniently create and track QR codes to the fullest.',
      continue: 'Continue',
      summayList: {
        a1: 'Your selected plan will be ready to be used immediately.',
        a2: 'You will receive an invoice by email with your billing details.',
        a3: 'You can change the plan at any time.',
        a4: 'If you are not completely satisfied, we will refund your money.',
      },
      step1: 'Invoicing',
      step2: 'Payment method',
      active: 'ACTIVE',
    },
    api: {
      header: 'API',
      description: 'Create static & dynamic QR Codes wherever you want in terms of seconds.',
      tabs: {
        item_2: 'Delete QR Codes',
        item_3: 'List QR Codes',
      },
      titleDesign: 'Example of plain QR Code design',
      titleColor: 'Example of QR Code with colors',
      code: {
        titleMethod: 'Request Method:',
        titleUrl: 'Request URL:',
        titleParameters: 'Request Parameters:',
        paramDescription: 'All Parameters need to be send as JSON object in the request body.',
        outcome: 'Outcome:',
      },
      table: {
        main: 'Main Parameters:',
        colorShape: 'Color & Shape Parameters:',
        frame: 'Frame Parameters:',
      },
    },
    unauthQr: {
      website: {
        title: 'Website URL',
        description: 'Redirect to website',
        appearance: {
          frame: 'FRAME',
          shape: 'SHAPE',
          logo: 'LOGO',
          level: 'LEVEL',
        },
      },
      pdf: {
        title: 'QR PDF',
        description: 'Show a PDF',
      },
      listofLinks: {
        title: 'QR List of Links',
        description: 'Group links',
      },
      apps: {
        title: 'QR Apps',
        description: 'Redirect to an app store',
      },
      images: {
        title: 'QR Images',
        description: 'Show an image gallery',
      },
      vcard: {
        title: 'QR vCard Plus',
        description: 'Share contact details',
      },
      social: {
        title: 'QR Social Media',
        description: 'Share your social profiles',
      },
    },
    month: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    },
    expirePopup: {
      title: 'Your trial plan will expire in',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      after: 'After',
      afterNext: ', you will lose access to the following features:',
      text1: 'Your dynamic QR codes will no longer be scannable.',
      text2: 'You will not be able to create new QR codes or edit existing ones.',
      text3: 'You will lose access to all of your tracking metrics.',
      text4: 'Downloads will no longer be available.',
      bottomText: 'To continue using platform without interruption, upgrade to one of our plans.',
    },
    errorPages: {
      couldNotLod: 'The page could not be loaded, please try again later.',
      poweredBy: 'Powered by',
      limitReached: 'The limit of total scans has been reached.',
      qrDeactivated: 'This QR code has been deactivated for some reason',
      qrDeactivatedSubTitle1: 'If you are the owner of this QR code, ',
      qrDeactivatedSubTitle2: 'log in',
      qrDeactivatedSubTitle3: ' to reactivate it.',
    },
    terms: {
      title: 'Terms of Service',
      lastUpdate: 'Last updated: August 1st, 2024',
      button: 'Create Qr Code',
    },
    popup: {
      qrDelete: 'QR deletion',
      qrDeleteSubtitle: 'The selected QR codes will be deleted. Are you sure?',
      leaveWithoutSaving: 'Leave without saving?',
      youHaveUnsavedChanges:
        'You have unsaved changes. If you exit now, your progress will be lost. Are you sure you want to leave this page?',
      stayOnPage: 'Stay on page',
      leaveAnyway: 'Leave anyway',
      accountDelete: 'Account deletion',
      accountDeleteSubtitle: 'All your data will be destroyed without the possibility of recovery. Are you sure?',
      emailUnsubscribe: 'Unsubscribe from emails',
      emailSubscribe: 'Subscribe to emails',
      emailUnsubscribeSubtitle: 'You will stop receiving emails. Are you sure?',
      emailSubscribeSubtitle:
        'You will start receive emails with important updates and information about your account.',
    },
    landing: {
      topTitle: 'Create free QR Codes instantly',
      topSubTitle: 'Personalize your QR codes with colors, shapes, and logos in just 3 easy steps.',
      topFirstBlockTitle: 'Choose Your QR Code Content',
      topFirstBlockSubTitle:
        'Create QR codes for anything—websites, PDFs, images, links, vCards, and more. Tailor it to fit your needs.',
      topSecondBlockTitle: 'Customize Your QR Code Design',
      topSecondBlockSubTitle: 'Add your details and use our generator to craft a QR code that’s uniquely yours.',
      topThirdBlockTitle: 'Download Your QR Code',
      topThirdBlockSubTitle:
        'Save your QR code in PDF, PNG, or SVG formats. Print it or share it digitally—quick and easy!',
      sliderTitle: 'Generate different types of QR Codes',
      sliderTopTitle: 'QR codes can hold a large amount of content and at QRBrain, we offer them all.',
      benefitTitle: 'QR-Brain makes all the difference',
      benefitSubTitle:
        '#1 QR code generator on the market, the indispensable tool for small and large businesses, create personalized QR codes with your logo, color and design, try it for 7 days completely free.',
      benefitPoints: {
        0: 'Unlimited QR codes',
        1: 'Scan without limits',
        2: 'Complete monitoring',
        3: 'White label (CNAME)',
      },
      benefitEnd: '...and many more!',
      anonymQr: {
        website: {
          title: 'Add Website URL & Design Your Code',
        },
        designYourQr: 'Design Your QR',
        pdf: {
          title: 'PDF',
        },
        listOfLinks: {
          title: 'List of Links',
        },
        vCard: {
          title: 'Complete the Content',
        },
        images: {
          title: 'Images',
        },
        social: {
          title: 'Social Media',
        },
        apps: {
          title: 'Apps',
        },
        more: {
          title: 'More Types Soon',
        },
        selectQrType: 'Select a QR type',
        designYourCode: 'Design Your Code',
      },
      qrCodeStarted: 'QR codes created',
      globalTrustUs: 'Global businesses trust us',
      ratedOnGoogle: 'Rated on Google',
      featuresList: {
        staticQrName: 'Static QRs',
        staticQrDescription: 'Non-expiring QR codes',

        editingManagementName: 'Editing and management of QRs',
        editingManagementDescription: 'QR codes that allow real-time updates',

        eventTrackingName: 'Event tracking',
        eventTrackingDescription: 'A helpful tool for tracking QR interactions.',

        templatesName: 'Templates',
        templatesDescription: 'Save and reuse your own designs',

        personalizationName: 'Editing and management of QRs',
        personalizationDescription: 'Personalize and arrange your QR codes',

        downloadFormatsName: 'Variety of downloads format',
        downloadFormatsDescription: 'Broaden the potential uses of your QR code',

        completeAnalyticsName: 'Complete Analytics',
        completeAnalyticsDescription: 'Gain insights into performance with in-depth data',

        customDomainName: 'Custom domain',
        customDomainDescription: 'Enhance your brand with a custom domain',

        unlimitedUsersName: 'Unlimited contributing users',
        unlimitedUsersDescription: 'Collaborate on managing your QR codes',

        passwordProtectionName: 'Password access and protection',
        passwordProtectionDescription: 'Ensures data privacy for authorized access',

        bulkCreationName: 'Bulk creation and download',
        bulkCreationDescription: 'Enhance the evaluation of your digital campaign.',

        pixelIntegrationName: 'Google and Facebook pixel integration',
        pixelIntegrationDescription: 'Enhance the evaluation of your digital campaign.',
      },
      benefitBlocks: {
        block0: {
          title: 'Dynamic and Static QR Codes',
          subtitle:
            'Design and manage both Dynamic and Static QR Codes with ease. Adjust the information of your Dynamic QR even after its creation! Connect in real time with your audience and update content on the fly without the need to reprint. Forget about limitations, we offer you total flexibility!',
        },
        block1: {
          title: 'Multiple landing pages',
          subtitle:
            "Discover a universe of options with our landing pages! You can select between PDF, vCard, Images, List of Links and much more. Adapt your message for different audiences and don't worry about access to your content. Our servers will guarantee you a seamless experience.",
        },
        block2: {
          title: 'Complete statistics',
          subtitle:
            'Strategic data at your fingertips. From total scans to link clicks, our statistics offer a detailed view of the interaction with your QRs. Know the operating systems, countries and preferred browsers to adapt your strategy precisely. Track your success with our comprehensive statistics!',
        },
        block3: {
          title: 'Customize your QR',
          subtitle:
            'Elevate your presence with a unique touch! Customize your QR with logos, colors and shapes to stand out and increase scanning possibilities. Reflect your identity and strengthen brand recognition with an attractive aesthetic. Stand out from the crowd with captivating QRs!',
        },
      },
      faq: {
        title: 'Everything you need to know to get started',
        subTitle:
          'In this section you will find the basic concepts and the necessary steps to start enjoying the benefits of using QR.',
        boxes: {
          0: {
            title: 'What is QR code?',
            text: 'The term “QR” stands for “quick response” and refers to instant access to the information contained in the Code. It is, in short, the evolution of the barcode, made up of patterns of black and white pixels. Denso Wave, a Japanese subsidiary of Toyota Denso, developed them in order to mark the components of their cars and thus speed up logistics in their production. Currently, it has gained great popularity, due to its versatility and accessibility, thanks to the functions of smart phones.',
          },
          1: {
            title: 'Know the benefits using QR',
            text: `You've likely observed that an increasing number of companies are incorporating QR codes as a key resource for marketing and promoting their products and services. Their rising popularity stems from the wide range of applications they offer: facilitating customer payments, sharing links to websites, catalogs, and price lists, collecting feedback on products or services, encouraging customers to share images or videos, promoting business events, and much more—all with just a simple scan!`,
          },
          2: {
            title: 'How to start using QR',
            text: `Many devices already come with a built-in QR code reader. To use it, simply open the camera on your mobile phone and hold it over the code for a few seconds until a notification appears on the screen. If this doesn’t happen, check your settings to ensure QR scanning is enabled. If your device doesn’t have this feature, you can easily download and install a QR code reader from your app store.`,
          },
        },
      },
      questions: {
        title: 'Do not leave with doubt',
        secondTitle: 'Want to know more?',
        description: 'Check our FAQs to find an answer to any questions you may have about our QR codes.',
        button: 'Answer all your questions',
        tabs: {
          basic: 'Basic info',
          design: 'Design & Creation',
          scan: 'Scan & print',
        },
        boxesBasic: {
          0: {
            title: 'What does QR generation mean?',
            text: 'It is a tool that enables you to easily and intuitively create various types of QR codes. With the increasing popularity of QR codes, our generator has become a go-to resource for individuals and businesses alike. It can be used by businesses of all kinds to create QR codes for websites, share PDFs, photo galleries, playlists, price lists or menus, connect customers with services offered by your business (such as WiFi access, appointments, payments, etc.), promote events with links to trailers, create vCards with contact information to share with clients, and much more.',
          },
          1: {
            title: 'Can I create an account to generate QR codes for free?',
            text: 'Absolutely, the first seven days are on us, allowing you to try our QR code generator for free.',
          },
          2: {
            title: 'Are QR codes available for free?',
            text: `Our QR code generator offers a seven-day free trial, allowing you to create and keep QR codes permanently. If you’re happy with the service, you can choose a plan that fits your needs. With a subscription, you'll gain unlimited access to all features: create unlimited dynamic and editable QR codes, explore various QR types, manage and edit your QRs, track unlimited scans, view comprehensive analytics, and download in multiple formats.`,
          },
          3: {
            title: 'Why do other services allow the creation of QR codes for free?',
            text: `This is because our QR codes are dynamic rather than static. All QR codes generated with QRBrain host information on our servers, such as PDF documents, videos, and images, which incurs a cost. Therefore, they are not free.`,
          },
          4: {
            title: 'Can the QRs that are generated be used for commercial purposes?',
            text: `QR codes have become an integral part of many companies' marketing strategies. Don’t hesitate to use the codes you generate on our platform to refresh, enhance visibility, and add dynamism to your business.`,
          },
          5: {
            title: 'What types of information can be stored in a QR?',
            text: `QR codes can hold a diverse range of information tailored to your needs. By scanning, users can be directed to various types of content, such as websites, PDFs, photo galleries, playlists, price lists, menus, technical support, WiFi networks, shift schedules, payment links, videos, contact details, and more. The possibilities are endless.`,
          },
          6: {
            title: 'Can I manage the codes using the QR code generator?',
            text: `Absolutely. Once you’ve subscribed to one of our plans, you can manage your QR codes however you like: create, design, save, delete, or modify them, add logos and frames, generate a domain, save your favorite designs, edit URLs, and more.`,
          },
          7: {
            title: 'How long are QR codes valid? Do they have an expiration date?',
            text: `QR codes do not expire; they remain functional unless you change or remove the link they point to. However, with dynamic QR codes, you can update the content or links as needed.`,
          },
          8: {
            title: 'Do QR codes come with a scan counter?',
            text: `Yes. With a subscription plan, you can monitor the number of scans your QR codes receive. This allows you to track your campaign's performance and make adjustments to enhance or expand your efforts.`,
          },
        },
        boxesDesign: {
          0: {
            title: 'Can I modify or update a QR code?',
            text: 'Our service enables you to adjust the content, fix errors, or update the link of a QR code even after it has been created. We understand that mistakes or changes may occur, so we offer the option to edit your QR codes without generating a new one. Simply go to the "My QR Codes" section, select the QR code you wish to modify, and make the necessary changes as often as needed, though changing the design type will require creating a new QR code.',
          },
          1: {
            title: 'Can I add my company’s isotype or logo to a QR code?',
            text: 'Absolutely! Adding your company’s isotype or logo to the QR code enhances its appeal and strengthens your brand’s visibility. You can use our free seven-day trial to explore this feature in our QR code generator.',
          },
          2: {
            title: 'Can I create QR codes in color, or are they only available in black and white?',
            text: `You can select any colors you like! Our QR code creator allows you to choose from a broad spectrum of #RRGGBB color options. You can use your company’s colors, match the aesthetics of your campaign, or let your creativity flow by combining colors as you see fit.`,
          },
          3: {
            title: 'Is it possible to create multiple QR codes for the same content?',
            text: `Certainly! You can create up to 40 distinct versions of a QR code for the same content, with options for four error correction levels and eight masking levels. Our QR code generator will select the optimal version based on the data amount and readability to ensure the highest quality image. Additionally, you can customize these different versions using our design tool.`,
          },
        },
        boxesScan: {
          0: {
            title: 'How can I scan or read a QR code with my smartphone?',
            text: 'Most iPhone and Android devices come with a built-in QR code reader. To use it, simply open your camera app and point it at the QR code. Hold it there for a few seconds until a notification appears on your screen. If the notification doesn’t show up, check your settings to ensure QR scanning is enabled. If your device doesn’t have this feature, you can download a QR code reader from your app store, many of which are free.',
          },
          1: {
            title: 'Are there any limits on the number of scans for QR codes?',
            text: 'No, QR codes can be scanned as many times as needed.',
          },
          2: {
            title: `Why isn't my QR code working?`,
            text: `There could be several reasons for this issue. The QR code might be blurry or the scanner may struggle to detect it if there's insufficient contrast between the code and the background. Ensure that the foreground color is always darker than the background. If you continue to experience problems, feel free to reach out to us.`,
          },
          3: {
            title: 'What steps should I take before printing my QR code?',
            text: `To prevent costly mistakes in your marketing campaign, make sure to verify your QR code’s functionality before printing. 
            Ensure that the colors have sufficient contrast for optimal legibility, with the foreground being darker than the background. Double-check that the information embedded in your QR code (such as URLs, email addresses, text, or maps) is accurate. Test the QR code by scanning it with devices running different operating systems.
            Additionally, confirm that the purpose or function of the QR code is clear in its presentation, so your clients understand what they need to scan it for.`,
          },
          4: {
            title: `In what graphic formats can QR codes be created?`,
            text: `Once you register on our site, you'll be able to download your codes in multiple formats: high-resolution JPG, PNG, and SVG.`,
          },
        },
      },
      footer: {
        generateTitle: 'Generate custom QR codes that tell your story',
        title: 'Try our QR code generator for 7 days free.',
        createBtn: 'Create qr code',
        logoDesc: 'Create custom QR Codes to elevate your business or idea.',
        copy: 'QR Code Generator - “QR Code” is a trademark of DENSO WAVE INCORPORATED',
        desc: 'Create custom QR Codes to elevate your business or idea.',
        company: 'Company',
        pricePlan: 'Plans and prices',
        tos: 'Terms of Service',
        privacy: 'Privacy Policy',
        dataDeletion: 'Account Deletion',
        qrCode: 'QR Codes',
        website: 'Website',
        pdf: 'PDF',
        vcard: 'vCard Plus',
        images: 'Images',
        lol: 'List of links',
        social: 'Social Media',
        apps: 'Apps',
        help: 'Help',
        contact: 'Contact us',
        faq: 'FAQ',
      },
      createQr: {
        titleLeft: 'Get your QR Code in ',
        titleRight: '30 Seconds',
      },
      howToCreateQr: {
        title: 'How to Create a QR Code?',
        step1: {
          title: 'Choose Your QR Code Content',
          text: 'Create QR codes for anything — websites, PDFs, images, links, vCards, and more. Tailor it to fit your needs.',
        },
        step2: {
          title: 'Customize and design QR-code',
          text: 'Add your details and use our generator to craft a QR code that’s uniquely yours.',
        },
        step3: {
          title: 'Download your code and share it',
          text: 'Save your QR code in PDF, PNG, or SVG formats. Print it or share it digitally — quick and easy!',
        },
      },
      tryQrCode: {
        title: 'Try Our QR Code Generator for 7 Days Free.',
      },
      createFreeAccount: 'Create Free Account',
      features: {
        title: 'QR Codes that',
        otherServices: 'Other Services',
        makeYouLookSmart: 'Make You Look Smart',
      },
      designYourCode: {
        title: 'Design Your Perfect QR Code Now',
        generate:
          'Generate high-quality QR codes optimized for any surface or screen. Download in multiple formats and customize your codes whenever you need.',
      },
      possibilities: {
        titleLeft: 'With QR Creator',
        titleRight: 'the Possibilities Are Endless',
        chooseType: 'Choose Type of QR',
        createQrCode: 'Create QR Code',
        website: {
          connect:
            'Connect your URL to a QR code so everyone can access your website quickly and easily. Turn every visit into an opportunity for growth!',
          provides:
            'Provides quick access to your website or online store with a simple scan, and optimizes the experience of users and potential customers',
          update:
            'Update the link as many times as you need without having to modify the printed QR code, always ensuring relevant content.',
        },
        pdf: {
          from: 'From menus to user guides to creative portfolios, give your clients access to PDF documents quickly and efficiently.',
          customize: 'Customize your QR code to reflect your brand, making access to your documents attractive.',
          adjust:
            'Adjust the content of your documents at any time, ensuring your clients always have access to the most recent version.',
        },
        links: {
          share:
            'Share links to your website, online store, portfolio and social media profiles all through a single Link Listing QR.',
          make: "Make it easier for your customers to quickly find what they're looking for by centralizing all your important information in one place.",
          allows:
            'Allows users to easily share your links with others, expanding your reach and connecting with a wider audience.',
        },
        vcard: {
          transform:
            'Transform your business card into an interactive digital experience, where your contacts can access all your information and social networks with just a scan.',
          customize:
            'Customize your vCard to reflect your professional identity, adding your photo, location and links to your social networks for a more complete presentation.',
          make: 'Make it easy for your contacts to save your details to their device with a single click, eliminating the need to manually enter information.',
        },
        images: {
          share:
            'Share memories and special moments like never before through a QR code, where each image tells a story and is accessible to everyone.',
          showcase:
            'Showcase your best product or event photos with a single scan, attracting potential customers with engaging and accessible visual content.',
          update:
            'Update your gallery with images of new releases, recent projects or highlights to keep your audience engaged.',
        },
        social: {
          simplify:
            'Simplify how users interact with your social media profiles using QR codes. Instantly connect your audience to your accounts, making it easy for them to follow, like, and engage with your content.',
          with: 'With a single scan, users can access your social media profiles, eliminating the need for manual searches and ensuring quick interaction.',
          update:
            'Update your social media links or information anytime, ensuring your audience always has the most relevant and up-to-date content.',
        },
        apps: {
          simplify:
            "Simplify the way users access your app with QR codes designed for seamless connectivity. Whether it's directing them to download links, app updates, or specific app features, QR codes bridge the gap effortlessly.",
          enable:
            'Enable users to instantly access your app or key app features with a single scan, saving time and improving user experience.',
          update:
            'Update app information or redirect links as needed, ensuring users always receive the most relevant and up-to-date content.',
        },
        coupon: {
          description:
            'Boost sales and customer loyalty with easy-to-scan coupon QR codes. Instantly deliver discounts and special offers to your customers, making it convenient for them to save money while increasing your conversion rates.',
          feature1:
            'With a single scan, customers can access your exclusive deals and promotions, eliminating the need for printed coupons and ensuring seamless redemption.',
          feature2:
            'Update your coupon offers or discount percentages anytime, ensuring your customers always have access to your latest and most attractive promotions.',
        },
        video: {
          description:
            'Enhance engagement with dynamic video content using QR codes. Instantly connect your audience to your videos, making it easy for them to watch tutorials, testimonials, or promotional content without typing long URLs.',
          feature1:
            'With a single scan, users can access your video content, eliminating the need for manual searches and ensuring immediate viewing experiences.',
          feature2:
            'Update your video links or content anytime, ensuring your audience always has access to your most recent and relevant video materials.',
        },
      },
      benefits: {
        headerTitle: 'OUR BENEFITS',
        title: 'QR Brain Makes All the Difference',
        rates: {
          title: 'High Conversion Rates',
          description:
            'Create high-performing QR codes that accurately represent your brand and design, resulting in high scan rates.',
        },
        qrs: {
          title: 'Dynamic & Static QRs',
          description:
            'Design and manage both Dynamic and Static QR Codes with ease. Adjust the information of your Dynamic QR even after its creation Connect in real time with your audience and update content on the fly without the need to reprint. Forget about limitations, we offer you total flexibility!',
        },
        notes: {
          title: 'Multiple Landing Pages',
          description:
            "Discover a universe of options with our landing pages! You can select between PDF, vCard, Images, List of Links and much more. Adapt your message for different audiences and don't worry about access to your content. Our servers will guarantee you a seamless experience.",
        },
        statistics: {
          title: 'Complete Statistics',
          description:
            'Strategic data at your fingertips. From total scans to link clicks, our statistics offer a detailed view of the interaction with your QRs. Know the operating systems, countries and preferred browsers to adapt your strategy precisely. Track your success with our comprehensive statistics!',
        },
        customization: {
          title: 'Customize Your QR',
          description:
            'Elevate your presence with a unique touch! Customize your QR with logos, colors and shapes to stand out and increase scanning possibilities. Reflect your identity and strengthen brand recognition with an attractive aesthetic. Stand out from the crowd with captivating QRs!',
        },
        download: {
          title: 'Easily Download, Share & Edit',
          description:
            'Keep the highest resolution for your OR codes, no matter what medium you print or display them on. Download in JPG, PNG, or SVG and edit their content at any time.',
        },
      },
      createQRToday: {
        title: 'Create Your QR Codes Today!',
        description:
          'Sign up for a free trial to start generating your customizable dynamic QR codes. Optimize performance with advanced analytics and branding features, and edit your QR codes anytime.',
      },
      qrsOn: {
        headerTitle: 'QR CODES ON',
        title: 'Our QRs in the wild.',
        bottles: 'Bottles & Cans',
        businessCards: 'Business Cards',
        pamphlets: 'Pamphlets',
        brochures: 'Brochures',
        productPacking: 'Product Packing',
        menu: 'Menu',
      },
      reviews: {
        headerTitle: 'Reviews',
        title: 'What Our Clients Love About QR Brain',
        description: 'through their reviews in',
      },
      faqBlock: {
        title: 'Get Answers to Your Questions',
        link: 'View All FAQs',
      },
    },

    landingSliderTitles: {
      website:
        'Take your business card to the next level with a QR code. Share more information about your profile and your company in an innovative and unique way. And the best of all, change the information in the QR code whenever you need to.',
      pdf: 'Share PDF files using a QR code. Forms, information and texts available to anyone in a quick and secure way.',
      vCard:
        'Take your business card to the next level with a QR code. Share more information about your profile and your company in an innovative and unique way. And the best of all, change the information in the QR code whenever you need to.',
      images:
        'Share images and photos like never before via QR code. Who knew that so many memories could be in a single QR code.',
      listOfLinks:
        'Gather in links the most relevant content to share with your audience and help your followers find yourself on social networks with a single QR scan.',
      social:
        'Facilitate access to your social networks: share all your profiles with this QR and allow your audience to always be up to date with your publications and content.',
      apps: 'Make it easy for users to download and install your application with a QR code. Save time spent on searching and generate a positive user experience.',
    },
    landingSliderButtons: {
      website: 'Create qr code for Website',
      pdf: 'Create qr code for PDF',
      vCard: 'Create qr code for Images',
      images: 'Create qr code for Images',
      listOfLinks: 'Create qr code for List of links',
      social: 'Create qr code for APPS',
      apps: 'Create qr code for APPS',
    },
    faq: {
      title0: 'How does billing work?',
      title1: 'What happens if I want to make changes on any QR Codes?',
      title2: 'Is there a free trial?',
      title3: 'How long will it take until I get my QR codes?',
      title4: 'What are the requirements to get my QR codes?',
      title5: 'Can I change my plan?',
      title6: 'What are my payment options?',
      title7: 'Can I use the QR codes generated during the trial period for commercial purposes?',
      title8: 'What about my QR codes once the trial period ends?',
      title9: 'Should I cancel the trial period if I am not going to continue using the platform?',
      title10: 'What type of access does the trial period give me?',
      title11: 'Do you offer refunds for unused subscription periods?',
      title12: 'What happens to my QR codes if my subscription is canceled?',
      subTitle0:
        'Start using our premium features by getting a 7-day free trial. The trial gets you access to all of our premium features for 7 days. If during these 7 days you decide you like the service, you can go ahead and choose a plan.',
      subTitle1: 'You can edit your QR Code as much as you like in your dashboard.',
      subTitle2:
        'Absolutely, the free trial lasts 7 days and you can create dynamic and static QR Codes. Static QR Codes will continue to work after the free trial expires.',
      subTitle3:
        'As soon as you pay for the product, Your customized QR Codes will be already created in your dashboard. The process takes less than a minute!',
      subTitle4:
        'You will need to tell us a couple of things like which Color & Shape you want for your QR Code, which QR Code type, and some other information that will allow us to create a compliant QR Code for you.',
      subTitle5:
        'Yes, you can upgrade, downgrade, or cancel your plan at any time from the dashboard or by visiting https://qrbrain.io/cancel-subscription. If you need help changing your account, reach out to us using our email (support@qrbrain.io).',
      subTitle6:
        'You can either pay with credit card or any debit card you want! All our payments are secured by Stripe.',
      subTitle7: 'Yes',
      subTitle8:
        'Your QR codes will be stored for three months after the trial period has ended. During this period you will not be able to access them until you contract one of our plans.',
      subTitle9: 'No. The free trial period automatically ends after 7 days. Only payment plans can be canceled.',
      subTitle10:
        'Our trial period gives you access to all of our tools. At QRBrain.io, we believe that in order to evaluate a service, you must be able to test it out completely.',
      subTitle11:
        'No refunds are offered for unused subscription periods. Users can prevent the subscription from automatically renewing by canceling it at any time',
      subTitle12:
        "Your QR codes won't go anywhere, but you won't be able to access them or the collected data until you update your plan. Your QR codes will disappear only if you delete your QRBrain.io account.",
      title: 'FAQs',
      date: "If you have any questions that you can't answer through our FAQs, don't hesitate to contact our team.",
    },
    plansAndPrices: {
      title: 'Plans & Pricing',
      subTitle: 'Try it for 7 days for free before subscribing to the plan that best suits your needs.',
      billedAnnually: 'Billed annually',
      billedSemiAnnually: 'Billed every semester',
      billedQuarterly: 'Billed quarterly',
      buy: 'Buy',
      bottomTitle: 'Value Added Tax not included in the amounts.',
      paymentsTitle: 'Payment methods',
      allPlans: 'All plans include:',
      month: 'month',
      months: '{{months}} months',
      faq: {
        title: 'Questions about Plans',
        changePlan: {
          summary: 'Can I change my plan?',
          details:
            'Once you subscribe to a plan, you can only make changes one month before your current subscription ends. Please note that you can cancel your plan at any time. If you have questions, contact us through this link.',
        },
        offerRefunds: {
          summary: 'Do you offer refunds for unused subscription periods?',
          details:
            'No refunds are offered for unused subscription periods. Users can prevent the subscription from automatically renewing by canceling it at any time',
        },
        fullAccess: {
          summary: 'Do I have full access with any plan?',
          details:
            'Yes. With any plan you will have total access to the tools to create QRS, statistics and download formats.',
        },
        free: {
          summary: 'Can I try it for free?',
          details: 'Of course, you have 7 days for free to try the app before choosing a paid plan.',
        },
        paymentMethods: {
          summary: 'What payment methods do you accept?',
          details:
            'We accept card payments (Mastercard, Visa). All payments will be made in the selected currency, and prices do not include value added tax.',
        },
        cancel: {
          summary: 'How can I cancel my subscription?',
          details:
            'You can cancel the subscription whenever you want without commitment from the Billing section in your account.',
        },
      },
    },
    privacy: {
      title: 'Privacy Policy of QRBrain',
      lastUpdate: 'Last updated: August 1st, 2024',
      text: {
        0: 'This Privacy Policy outlines how we collect, use and share personal data of people who use or are connected to our services, are interested in QRBRain or its services, or to whom we wish to market our services. This Privacy Policy also provides you with information on your rights as a data subject and how to reach us if you have any questions.',
        1: 'This Privacy Policy does not apply to the practices of other businesses that QRBrain does not own or control, including other companies’ websites, services and applications (“Third Party Services”) that you can access through the Services or to individuals that QRBrain does not manage or employ. We encourage you to review the privacy policies of any Third Party Services you access or use. Please note that we cannot take responsibility for the content or privacy policies of Third Party Services, and any third party policies linked to this Privacy Policy are strictly for informational purposes only.',
        2: 'Please note that our privacy practices are subject to the applicable laws of the regions in which we operate. Accordingly, some additional region-specific terms will only apply to individuals in those locations, or as required by applicable laws. If you are a United States resident of California, Virginia, Colorado, Connecticut or certain other U.S. states, please see the sections titled California Privacy Rights, and Virginia/Colorado/Connecticut and certain other U.S. State Privacy Rights for specific disclosures with respect to our collection, use, and disclosure of your information and additional rights you have under applicable U.S. laws.',
      },
      contactInfo: {
        title: 'Contact Information',
        0: 'This Privacy Policy describes the policies and procedures of QRBrain, Calle Federica Montseny 18, 28049, Madrid (Spain) for the collection, use, and disclosure of personal data about you for which either of us act as the data controller, or for which we act as joint controllers, in accordance with the European Data Protection Regulation (“GDPR”) and other applicable laws.',
        1: 'If you have any questions or concerns regarding privacy when using the Services of QRBrain wish to use your rights, such as to object to the processing or have your personal data removed, please send us a detailed message to: support@qrbrain.io. We will make every effort to resolve your concerns. Please also see "Rights of Data Subjects" for more detailed information on your rights as the data subject.',
      },
      qrService: {
        title: 'QRBrain services',
        0: 'QRBrain collects personal data about you from the following sources, as described in this Privacy Policy, when you (i) register for the Site and the Services, through your user account with QRBrain, including registering through a third-party service (your “Account”); (ii) use the Services; or (iii) view or interact with a QRBrain link, QR Code, Link in Bio. We collect the following types of information from you, some of which might be considered personal data under applicable law:',
        subtitle: ' When You Register for a QRBrain Account',
        1: 'When you create an Account, we collect the personal data from you, such as your name, phone number,company  name, industry, job title, company size, email address, phone number and sign-in information.If you create an Account using your login information from a third-party account, such as Google,Facebook, Apple, Linkedin or X, we will access and collect the personal data about you that the third-party account provides (which is based on your privacy settings with the third-party account), so that you can log into your Account with us. We use your contact information to send you information about our Services and communicate with you about your Account, your activities on our Site and Services and policy changes. You may unsubscribe from receiving certain types of these messages through your Account settings, although QRBrain reserves the right to contact you when we believe it is necessary, such as for administrative and account management purposes.',
        2: `We may receive a conﬁrmation when you open an email from us. We use this conﬁrmation to improve our customer service. You have the opportunity to add sub-users to your Account. If you create a sub-user, the following personal data of the sub-user will be processed: Name, email address, IP address of the user's device, date and time of sub-user creation, login information, employer, phone number.`,
        3: 'Some features of the Services allow registered users to provide their own content to the Services, such as written descriptions of URLs, comments, images and video. Unless you request deletion of your personal data as described in this Privacy Policy, all content submitted by you to the Services may be retained by QRBrain, even after you terminate your Account and may continue to be shared by third parties, as described in this Privacy Policy.',
      },
      contract: {
        title: 'Contracts, Purchase Orders and Invoicing',
        0: 'For any individual that acts as the contact person for our customer, supplier, partner or other entity that we conduct or wish to conduct business with, we process the following information:',
        item: {
          0: 'Basic information (such as name, title, company name, work location and contact information)',
          1: 'Business connections',
          2: 'Communications',
        },
        1: 'The individual acting as the contact person in a primary source of information, but the personal data may also be collected from your employees, your colleagues, and our (other) customers, suppliers and partners. The personal data is used to discuss business, pursue business opportunities, send notifications related to our services and otherwise communicate with you, contracting, invoicing and making payments. The processing is based on our legitimate interests to comply with contractual obligations, or the terms of agreements we have (or have had), maintaining relationships, and operating our business. In addition, the invoicing related personal data will be used in accounting and reporting, which processing shall be based on our obligations under the law.',
      },
      website: {
        title: 'Website and contact requests',
        0: `QRBrain process personal data gathered when you use or access their respective websites, including any and all subdomains of the sites (each "Site", as applicable), respectively. Each time Site is accessed, our system automatically collects data and relevant information from the computer system of the calling device.`,
        1: 'The following data is collected:',
        item: {
          0: 'Browser type and version used',
          1: `The user's operating system`,
          2: `The user’s internet service provider`,
          3: 'The IP address of the user',
          4: 'Date and time of access',
          5: `Web pages from which the user’s system accessed our website`,
          6: `Web pages accessed by the user’s system through our website`,
        },
        2: 'This data is stored in the log files of our system. This data is not stored together with other personal data of the user. The temporary storage of the IP address by the system is necessary for the delivery of the website to the computer of the user. For this purpose, the user’s IP address must be kept for the duration of the session. The storage in log files is done to ensure the functionality of the website. The data is also used to optimize the website and to ensure the security of our IT systems. An analysis of this data for marketing purposes does not take place. The legal basis for the temporary storage and other processing described above of data and log files is our legitimate interest to maintain functionality and ensure security of our website.',
        3: 'If you connect with us using various social media platforms and/or professional networks, please note that QRBrain does not control or have influence over how those platforms process your personal data. We recommend that you contact those third party platforms directly for information on their processing. Here are some links for your convenience:',
        links: {
          0: {
            title: 'Twitter:',
            link: 'https://twitter.com/de/privacy',
          },
          1: {
            title: 'YouTube:',
            link: 'https://policies.google.com/privacy?gl=DE&hl=en',
          },
          2: {
            title: 'LinkedIn:',
            link: 'https://www.linkedin.com/legal/privacy-policy',
          },
        },
        4: 'QRBrain may use third-party APIs and software development kits (“SDKs”) to provide certain functions in our Services. We use cookies and similar technologies for the following purposes: Technically necessary; Comfort; Statistics; Marketing. When we use cookies and/ or similar techniques for processing personal data, the types of personal data processed may vary, depending on the categories of cookies or similar techniques. Non-essential cookies are used only with your consent. You have the option of preventing cookies from being',
        5: 'Please see our Cookie Policy and EU Cookie Policy to learn how QRBrain and its partners use cookies or similar technologies to analyze trends, administer the website, track users’ movements around the website, and to gather demographic information about our user base.',
      },
      business: {
        title: 'Business transfers',
        0: 'We may transfer and/or provide information about our users in connection with an acquisition, sale of company assets, or other situation where user information would be transferred as one of our business assets. You will be notiﬁed via email and/or a prominent notice on our website. In such a case, the acquirer of QRBrain may continue to use your information as set forth in this policy or as otherwise allowed by law.',
        subtitle1: 'Protection of QRBrain and others',
        1: 'QRBrain may access, read, preserve, and disclose any information it collects when it has a good faith belief that doing so is reasonably necessary to (i) comply with a law, regulation, or compulsory legal request, including process from a governmental law enforcement or national security agency, (ii) enforce this Privacy Policy or our Terms of Service, including investigation of potential violations hereof, (iii) detect, deter, prevent or otherwise address malicious, fraudulent or unlawful activity, (iv) respond to user support requests, or (v) protect the rights, property or safety of QRBrain, its users and the public. This includes exchanging information with other companies and organizations for protection from malicious, fraudulent or unlawful activity.',
        2: 'Limitation period of the possible out-standing payments (debt), whichever occurs later under the applicable laws, have passed. Subscription data, product usage data and similar data based on actions of the users is anonymized or erased after three (3) years have passed from the year during which the account was deactivated.',
      },
      web: {
        title: 'Web Tracking and Statistics',
        0: 'We use web tracking solutions to continuously improve the content and our site from a technical, design and editorial point of view and to make it more convenient for you. Based on the statistical findings on browser type and operating system, we can optimize our web design.',
        1: `By using these methods, we do not obtain any personal data about you, but rather only statistical information about the use of our websites and products. In this way, we learn, for example, which our websites content is particularly popular, at what times our website is used particularly intensively, via which pages our users reach our site, from where the user has dialed into the Internet before visiting the site, and which browsers and operating systems our users generally use when surfing on our websites. We use this information to continuously improve the content and our site from a technical, design and editorial point of view and to make it more convenient for you. The collected data is stored in a so-called tracking session together with an anonymous user ID (unique hash from browser properties and the current time). Additionally the data collection and processing takes place at all times without personal reference. The statistics are used to enable and enhance the functionality and performance of our website and services and to understand user behavior to improve our website, services and customer experience. The tracking pixel data is stored on the users' device for up to 12 months.`,
      },
      customer: {
        title: 'Customer support and management',
        0: 'QRBrain works together to provide support services to our customers, and to administer and manage the customer relationships by sharing and using the following personal data:',
        item: {
          0: 'Account information, subscriptions to the Services, billing information, and payment data,',
          1: 'Personal data included to the business information (if corporate customer) and accounting information,',
          2: 'User events, account creation, product usage and other usage data (such as logs, encodes, decodes, and page views) from Services,',
          3: 'Credentials to customer support channel(s) and other tools we may provide,',
          4: 'Communications with the customer,',
          5: 'IP address,',
          6: 'Social media profile information, interactions, contents and other user generated information.',
        },
        1: 'The data sources are the companies part of QRBrain. Subject to your consent, we collect information above from your use of our Site and Services by cookies and similar technologies (see our Cookie Policies) to be shared and used across QRBrain. We use the personal data we collect for a variety of administrative and business purposes including:',
        item1: {
          0: 'Respond to inquiries, questions and comments and provide customer and technical support, provide access to certain functionalities of our Services,',
          1: 'Provide centralized support for customers with extended support hours,',
          2: 'Efficient and centralized sales related communication and activities with extended support hours,',
          3: 'Maintain central platform for customer communication,',
          4: 'Align on and more efficiently communicate with our current and prospective customers concerning our Services,',
          5: 'Allow our customers to understand interactions with our Services,',
          6: `Analyzing customer and visitor's website usage behavior for better understanding of customers and visitors needs and wishes,`,
          7: 'To help detect, deter and prevent malicious, fraudulent or unlawful activity to protect our Services and customers, and malfunction of the Sites and Services,',
          8: 'Manage payments and customer records,',
          9: 'Use common financial planning and managing to align and implement group financial strategies and policies.',
        },
        2: 'We process your data to provide customer support, customer communications, to optimize and improve our service and the user experience, and to process and manage payments, or to the extent the purpose of the contact is to conclude a contract or if you already have an Account or otherwise use our Service because such processing and contact is necessary to conclude the contract or provide the Service. The data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected, to the extent further storage is not permitted or required by law.',
        3: 'When a user deactivates their account (or we do it based on long-term inactivity), the account information is anonymized. Payment data is anonymized or erased after the retention period for accounting records and the limitation period of the possible out-standing payments (debt), whichever occurs later under the applicable laws, have passed. Subscription data, product usage data and similar data based on actions of the users is anonymized or erased after three (3) years have passed from the account deactivation or last contact.',
      },
      marketing: {
        title: 'Marketing',
        0: 'QRBrain works together to provide support services to our customers, and to administer and manage the customer relationships by sharing and using the following personal data:',
        item: {
          0: 'Account information and subscriptions to the Services',
          1: 'Other contact details than connected to a registered account',
          2: 'Personal data included to the business information (if corporate customer)',
          3: 'User events, account creation, product usage and other usage data (such as logs, encodes, decodes, and page views) from Services',
          4: 'Social media profile information, interactions, contents and other user generated information',
          5: 'Messaging content that individuals choose to share (e.g., social media messages, in-app messages, SMS)',
          6: 'Social media and messaging metadata (e.g., number of social media followers, number of posts, number of tweets)',
          7: 'Any content, communications, messages, data, and information sent or received by customer through the Services',
          8: 'Other individual information (e.g., age, gender, employer, profession, geographic location, education information, financial status, interests and preferences) available on social media or public sources',
        },
        1: 'QRBrain uses personal data obtained through following third party Ads campaigns platforms, received as described in this Privacy Policy: Google Analytics & Ads, LinkedIn Ads & Marketing, Facebook Ads and Microsoft Advertising.',
        2: 'We use the personal data we collect for marketing purposes to:',
        item2: {
          0: 'Align on marketing operations and marketing strategies,',
          1: 'Run common marketing campaigns',
          2: 'Serve end users with interest–based advertising, as well as to measure the effectiveness of advertising campaigns',
          3: 'Interact with (potential) customers and business partners to promote QRBrain Services',
        },
        3: `We collect personal data for purposes above through tracking technologies of online marketing partners in connection with our QR Code services as identified in our cookie banner and policy. The legal basis for processing personal data as necessary for marketing is our legitimate interests to promote sales and increase awareness of QRBrain, and communicate with our interest groups. Where marketing requires consent under applicable mandatory laws, for example if we wish to market via email our Services to a new customer who is a natural person in the EU, the legal basis is the recipient's consent. If you have given us your consent to share your data with a third-party provider, the legal basis for the data processing is your consent. However, a third-party provider may also form part of our (pre)contractual services, in which case the legal basis for the data processing is that the processing is essential to provide the services. The data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected, to the extent further storage is not permitted or required by law.`,
      },
      gdpr: {
        title: 'Rights under the GDPR',
        0: 'If you are a resident of the EEA or Switzerland, or otherwise subject to the GDPR, and we process your personal data, you have the right to ask for the following rights:',
        item: {
          0: 'In all cases a right to be informed about processing by QRBrain that pertains to personal data based on which you may be identified, and access to a copy of such personal data (Art. 15 GDPR).',
          1: 'If the personal data that is being processed is incorrect or inaccurate, you are entitled to demand for the data to be corrected (Art. 16 GDPR).',
          2: 'Subject to the conditions set in the GDPR, you may demand for the deletion or limitation of the processing and have the right to object to the processing altogether (Art. 17, 18, and 21 GDPR).',
          3: 'If the processing is based on your consent or a contract and the processing of data is carried out using automated procedures, you may be entitled to data transferability (Article 20 GDPR).',
          4: 'If you have consented to the processing of your data by the data controller, you may revoke your consent at any time. The legality of the data processing carried out on the basis of the consent that was obtained prior to the revocation will not be affected.',
        },
        1: 'Furthermore, you have a right to appeal to the competent supervisory authority (Art. 77 GDPR) if you deem the personal data processing by us to violate the GDPR or other applicable data protection laws.',
        subunder: 'International transfer of personal data',
        2: 'Depending on your location, information about you may be transferred to the United States or other countries outside the EU or European Economic Area (EEA) or may be processed there. These data transfers are necessary to provide you with the Services and functionalities you have requested as outlined in this policy.',
        3: 'To protect your personal data, we rely on appropriate legal basis for each data transfer. In particular, we use contractual safeguards such as Standard Contractual Clauses approved by the European Commission. Where applicable, we base data transfers also on adequacy decisions issued by the European Commission.',
        4: 'Please feel free to contact us for further information about international data transfers, including to obtain access to a copy of applicable safeguards.',
      },
      california: {
        title: 'California Privacy Rights',
        0: `The California Consumer Privacy Act of 2018 (“CCPA”), as amended by the California Privacy Rights Act of 2020, provides you with specific rights regarding your "personal information," as that term is defined under the CCPA. This section describes the rights that California consumers have and explains how to exercise those rights. For the purposes of this section, personal information does not include: (i) information that is lawfully made available from federal, state or local government records; (ii) de-identified or aggregated data; or (iii) information excluded from the scope of the CCPA. To be clear, these rights are granted only to the extent that you are a California consumer and we are acting as a “business” under the CCPA with respect to your personal information. The rights in this section are not intended to grant you additional rights, but only your rights under the CCPA.`,
        1: `We do not use or disclose sensitive personal information, as that term is defined under the CCPA. The categories of personal information described above are anonymized or erased from our systems upon request, if the data is detected as irrelevant in our automated or manual system maintenance, or after 3 years following the last contact with the relevant individual, whichever occurs first.`,
        sub1: 'Selling or Sharing of Personal Information',
        2: 'QRBrain does not “sell” or “share” your personal information to third parties, as those terms are used in the CCPA.',
        sub2: 'Rights to Your Information',
        3: 'a. Right to Know',
        4: 'As a California consumer, you have the right to request that we disclose certain information to you about our collection, use, disclosure, or sale/sharing of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request (see Exercising Your Rights, below), and subject to certain limitations that we describe below, we will disclose such information. You have the right to request any or all of the following:',
        sub3: 'The categories of personal information we collected about you.',
        5: `The categories of sources from which the personal information is collected. Our business or commercial purpose for collecting or selling that personal information. The categories of third parties with whom we share that personal information. The specific pieces of personal information we collected about you (see Data Portability Rights below).`,
        6: 'b. Right to Delete',
        7: 'You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request (see Exercising Your Rights, below), we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies. However, we may retain personal information that has been de-identified or aggregated. Furthermore, we may deny your deletion request if retaining the information is necessary for us or our service provider(s) to perform certain actions set forth under the CCPA, such as detecting security incidents and protecting against fraudulent or illegal activity.',
        8: 'c. Right to Data Portability',
        9: 'You have the right to request a copy of the personal information we have collected and maintained about you in the past 12 months. The CCPA allows you to request your information from us up to twice during a 12-month period. We will provide our response in a readily usable (and usually electronic) format.',
        10: 'd. Right to Correct',
        11: 'You have the right to request the correction of any personal information we maintain about you.',
        12: 'e. Right to Non-Discrimination',
        13: 'We will not discriminate against you for exercising any of your CCPA rights, including but not limited to, by:',
        14: `Denying you goods or services. Charging you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties. Providing you a different level or quality of goods or services. Suggesting that you may receive a different price or rate for goods or services or a different level or quality of goods or services.`,
        15: 'f. Exercising Your Rights',
        16: 'To exercise the rights described above, please contact us by using the following methods',
        17: 'Emailing us at support@qrbrain.io',
        18: 'After submitting a request, we will take steps to verify your identity in order for us to properly respond and confirm that it is not a fraudulent request. In order to verify your identity, we will ask, at a minimum, that you provide your name, email address, and relationship to us, so that we can seek to match this information with the information existing in our systems. When providing us this information, you represent and affirm that all information provided is true and accurate. Depending on the request, if we are unable to verify that the consumer submitting the request is the same individual about whom we have collected personal information, we may contact you for more information, or we may not be able to meet your request.',
        19: 'Only you, or an agent legally authorized to act on your behalf, may make a verifiable request related to your personal information. If you are making a request as the authorized agent of a California consumer, we will ask you to submit reliable proof that you have been authorized in writing by the consumer to act on such consumer’s behalf.',
        20: 'We will make every effort to respond to your request within 45 days from when you contacted us. If you have a complex request, the CCPA allows us up to 90 days to respond. We will still contact you within 45 days from when you contacted us to let you know we need more time to respond.',
        21: `California “Shine the Light” In addition to the above rights, under California Civil Code Section 1798.83 (“Shine the Light”), California residents may have the right to request in writing from businesses with whom they have an established business relationship: (a) a list of the categories of personal information, as defined under Shine the Light, such as name, email address, and mailing address, and the type of services provided to the customer that a business has disclosed to third parties (including affiliates that are separate legal entities) during the immediately preceding calendar year for the third parties’ direct marketing purposes; and (b) the names and addresses of all such third parties. To request the above information, please contact us by email at support@qrbrain.io. If you do not want your personal information shared with any third party who may use such information for direct marketing purposes, then you may opt out of such disclosures by sending an email to us at support@qrbrain.io.`,
        22: 'Contacting Us',
        23: 'If you have questions or concerns about this privacy policy, your California privacy rights, or our information practices, please email us at support@qrbrain.io.',
      },
      virgina: {
        title: 'Virgina/Colorado/Connecticut and certain other US State Privacy Rights',
        0: 'The Virginia Consumer Data Protection Act, the Colorado Privacy Act, and the Connecticut Data Privacy Act and similar laws in other U.S. states (“State Privacy Laws”) provide their consumers with specific rights regarding their personal data. To the extent that you are a resident of one of these states, this section describes your rights under the State Privacy Laws and explains how you may exercise these rights.',
        1: 'The categories of personal data we process, our purposes for processing your personal data, the categories of personal data that we share with third parties, and the categories of third parties with whom we share it are set forth in the terms of the Privacy Policy above.Rights to Your Information',
        2: 'In addition to the rights set forth in our Privacy Policy, the State Privacy Laws provide you with the following rights:',
        item: {
          0: {
            title: 'Right to know.',
            desc: 'You have the right to know whether we process your personal data and to access such personal data.',
          },
          1: {
            title: 'Right to data portability.',
            desc: 'You have the right to obtain a copy of your personal data that you previously provided to us in a portable and, to the extent technically feasible, readily usable format that allows you to transmit the data to another business without hindrance, where the processing is carried out by automated means. You may request such personal data up to twice annually, subject to certain exceptions.',
          },
          2: {
            title: 'Right to delete.',
            desc: 'You have the right to delete personal data that you have provided by or that we have obtained about you. Please note that we may deny such a request if the requested deletion falls under an exception as set forth in the State Privacy Laws. Additionally, if you request deletion of your personal data and we have obtained such information from a third-party source, we may retain such data by keeping a record of the deletion request and the minimum data necessary to ensure that your personal data remains deleted from our records and that such retained data is not used for any other purpose, or we may opt you out of the processing of such personal data for any purpose except for those allowed under the State Privacy Laws.',
          },
          3: {
            title: 'Right to opt out.',
            desc: 'You have the right to opt out of the processing of the personal data for purposes of: (i) targeted advertising; (ii) the sale of personal data; or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning you. As of the latest date of the Privacy Policy:',
            subItems: {
              0: 'We do not process personal data for the purposes of targeted advertising;',
              1: 'We do not sell your personal data; and',
              2: 'We do not engage in profiling decisions based on your personal data that produce legal or similarly significant effects concerning you.',
            },
          },
          4: {
            title: 'Right to correct.',
            desc: 'You have the right to correct inaccuracies in your personal data, taking into account the nature of the personal data and the purposes for which we process it.',
          },
          5: {
            title: 'Right to nondiscrimination.',
            desc: 'You have the right not to receive discriminatory treatment by us for the exercise of your privacy rights. Unless permitted by the State Privacy Laws, we will not:',
          },
        },
        3: `Deny you goods or services; Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties; Provide you a different level or quality of goods or services; or Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services. How to Exercise Your Rights; Verifying Your Identity`,
        4: 'To exercise any of your privacy rights, or if you have any questions about your privacy rights, you may contact us by:',
        5: 'Emailing us at support@qrbrain.io',
        6: 'After submitting a request, we will take steps to verify your identity in order for us to properly respond and/or confirm that your request is not fraudulent. We may contact you for additional information as reasonably necessary to authenticate your request, but if we are ultimately unable to authenticate your request using reasonable commercial efforts, then we may not be able to comply with it.',
        7: 'Only you or your authorized agent may make a verifiable request related to your personal data. If you are making a request as the parent or legal guardian of a known child regarding the processing of that child’s personal data, we may ask you to submit reliable proof of your identity.',
        8: 'Response Time; Your Right to Appeal',
        9: 'We will make every effort to respond to your request within 45 days from when you contacted us. If you have a complex request, the State Privacy laws allow us up to 90 days to respond. We will contact you within 45 days from when you contacted us to inform you of the need for additional time and the reason for such extension. We may charge you a reasonable fee to cover administrative costs if your requests are manifestly unfounded, excessive, or repetitive.',
        10: 'If we decline to take action on a request that you have submitted, we will inform you of our reasons for doing so, and provide instructions for how to appeal the decision. You will have the right to appeal within a reasonable period of time after you have received our decision. Within 60 days (45 days for residents of Colorado) of our receipt of your appeal, we will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If we deny your appeal, we will provide you with a method for contacting your state attorney general’s office to submit a complaint.',
        sub: 'Nevada Privacy Rights',
        11: 'If you are a resident of Nevada, you have the right to opt out of the sale of certain personal data that we have collected (or may collect) from you to data brokers or other third parties. You can exercise this right by emailing us at support@qrbrain.io with the subject line “Nevada Do Not Sell Request.”',
      },
      children: {
        title: 'Children’s Privacy',
        0: 'We do not knowingly collect personal data from children. If we learn that we have collected personal data of a child under 13 (or older as required by applicable law), we will take steps to delete such information from our systems as soon as possible. If you believe we might have any personal data from or about a child under 13, please contact us at support@qrbrain.io.',
      },
      dataprivacy: {
        title: 'Data Privacy Framework (EU-US, UK Extension and Swiss-US)',
        0: 'QRBrain complies with the EU-U.S. Data Privacy Framework (EU-U.S. DPF), the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) as set forth by the U.S. Department of Commerce. QRBrain has certified to the U.S. Department of Commerce that it adheres to the EU-U.S. Data Privacy Framework Principles (EU-U.S. DPF Principles) with regard to the processing of personal data received from the European Union in reliance on the EU-U.S. DPF and from the United Kingdom (and Gibraltar) in reliance on the UK Extension to the EU-U.S. DPF. QRBrain has certified to the U.S. Department of Commerce that it adheres to the Swiss-U.S. Data Privacy Framework Principles (Swiss-U.S. DPF Principles) with regard to the processing of personal data received from Switzerland in reliance on the Swiss-U.S. DPF. If there is any conflict between the terms in this privacy policy and the EU-U.S. DPF Principles and/or the Swiss-U.S. DPF Principles, the Principles shall govern. To learn more about the Data Privacy Framework (DPF) program, and to view our certification, please visit https://www.dataprivacyframework.gov/.',
        1: 'In compliance with the EU-U.S. DPF and the Swiss-U.S. DPF, QRBrain commits to refer unresolved complaints concerning our handling of personal data received in reliance on the EU-U.S. DPF and the Swiss-U.S. DPF to JAMS Data Privacy Framework Dispute Resolution, an alternative dispute resolution provider based in the United States. If you do not receive timely acknowledgment of your DPF Principles-related complaint from us, or if we have not addressed your DPF Principles-related complaint to your satisfaction, please visit https://www.jamsadr.com/eu-us-data-privacy-framework for more information or to file a complaint. The services of JAMS Data Privacy Framework Dispute Resolution are provided at no cost to you.',
      },
      change: {
        title: 'Changes to our Privacy Policy',
        0: 'We reserve the right to make changes to this Privacy Policy at any time. If we make material changes in the way we collect or use information, we will provide notice by posting an announcement on the Services or sending you an email, and we will indicate when those changes will become effective. You are agreeing to any changes to the Privacy Policy when you use the Services after those changes become effective.',
      },
    },
    toc: {
      general: {
        title: 'General Terms',
        0: 'By accessing and placing an order with QRBrain.io, you confirm that you are in agreement with and bound by the terms of service contained in the Terms & Conditions outlined below. These terms apply to the entire website and any email or other type of communication between you and QRBrain.io.',
        1: 'Under no circumstances shall QRBrain.io team be liable for any direct, indirect, special, incidental or consequential damages, including, but not limited to, loss of data or profit, arising out of the use, or the inability to use, the materials on this site, even if QRBrain.io team or an authorized representative has been advised of the possibility of such damages. If your use of materials from this site results in the need for servicing, repair or correction of equipment or data, you assume any costs thereof.',
        2: 'QRBrain.io will not be responsible for any outcome that may occur during the course of usage of our resources. We reserve the rights to change prices and revise the resources usage policy at any moment.',
      },
      license: {
        title: 'License',
        0: 'QRBrain.io grants you a revocable, non-exclusive, non-transferable, limited license to download, install and use the website strictly in accordance with the terms of this Agreement.',
        1: 'These Terms & Conditions are a contract between you and QRBrain.io (referred to in these Terms & Conditions as "QRBrain.io", "us", "we" or "our"), the provider of the QRBrain.io website and the services accessible from the QRBrain.io website (which are collectively referred to in these Terms & Conditions as the "QRBrain.io Service").',
        2: 'You are agreeing to be bound by these Terms & Conditions. If you do not agree to these Terms & Conditions, please do not use the QRBrain.io Service. In these Terms & Conditions, "you" refers both to you as an individual and to the entity you represent. If you violate any of these Terms & Conditions, we reserve the right to cancel your account or block access to your account without notice.',
      },
      definitions: {
        title: 'Definitions and key terms',
        0: 'To help explain things as clearly as possible in this Terms & Conditions, every time any of these terms are referenced, are strictly defined as:',
        item: {
          0: 'Cookie: small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.',
          1: 'Company: when this policy mentions “Company,” “we,” “us,” or “our,” it refers to QRBrain.io, which is responsible for your information under these Terms & Conditions.',
          2: 'Country: where QRBrain.io or the owners/founders of QRBrain.io are based, in this case is AR',
          3: 'Device: any internet connected device such as a phone, tablet, computer or any other device that can be used to visit QRBrain.io and use the services.',
          4: 'Service: refers to the service provided by QRBrain.io as described in the relative terms (if available) and on this platform.',
          5: 'Third-party service: refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you.',
          6: `Website: QRBrain.io's site, which can be accessed via this URL: https://qrbrain.io`,
          7: 'You: a person or entity that is registered with QRBrain.io to use the Services.',
        },
      },
      restrictions: {
        title: 'Restrictions',
        0: 'You agree not to, and you will not permit others to:',
        item: {
          0: 'License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the website or make the platform available to any third party.',
          1: 'Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the website.',
          2: 'Remove, alter or obscure any proprietary notice (including any notice of copyright or trademark) of QRBrain.io or its affiliates, partners, suppliers or the licensors of the website.',
        },
      },
      return: {
        title: 'Return and Refund Policy',
        0: 'Thanks for shopping at QRBrain.io. We appreciate the fact that you like to buy the stuff we build. We also want to make sure you have a rewarding experience while you’re exploring, evaluating, and purchasing our products.',
        1: `As with any shopping experience, there are terms and conditions that apply to transactions at QRBrain.io. We’ll be as brief as our attorneys will allow. The main thing to remember is that by placing an order or making a purchase at QRBrain.io, you agree to the terms along with QRBrain.io.'s Privacy Policy.`,
        2: `If, for any reason, you are not completely satisfied with any good or service that we provide, don't hesitate to contact us and we will discuss any of the issues you are going through with our product.`,
      },
      suggest: {
        title: 'Your Suggestions',
        0: 'Any feedback, comments, ideas, improvements or suggestions (collectively, "Suggestions") provided by you to QRBrain.io with respect to the website shall remain the sole and exclusive property of QRBrain.io.',
        1: 'QRBrain.io shall be free to use, copy, modify, publish, or redistribute the Suggestions for any purpose and in any way without any credit or any compensation to you.',
      },
      consent: {
        title: 'Your Consent',
        0: `We've updated our Terms & Conditions to provide you with complete transparency into what is being set when you visit our site and how it's being used. By using our website, registering an account, or making a purchase, you hereby consent to our Terms & Conditions.`,
      },
      links: {
        title: 'Links to Other Websites',
        0: 'These Terms & Conditions apply only to the Services. The Services may contain links to other websites not operated or controlled by QRBrain.io. We are not responsible for the content, accuracy or opinions expressed in such websites, and such websites are not investigated, monitored or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Terms & Conditions are no longer in effect. Your browsing and interaction on any other website, including those that have a link on our platform, is subject to that website’s own rules and policies. Such third parties may use their own cookies or other methods to collect information about you.',
      },
      cookies: {
        title: 'Cookies',
        0: 'QRBrain.io uses "Cookies" to identify the areas of our website that you have visited. A Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use Cookies to enhance the performance and functionality of our website but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable or you would be required to enter your login details every time you visit the website as we would not be able to remember that you had logged in previously. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies, you may not be able to access functionality on our website correctly or at all. We never place Personally Identifiable Information in Cookies.',
      },
      change: {
        title: 'Changes To Our Terms & Conditions',
        0: 'You acknowledge and agree that QRBrain.io may stop (permanently or temporarily) providing the Service (or any features within the Service) to you or to users generally at QRBrain.io’s sole discretion, without prior notice to you. You may stop using the Service at any time. You do not need to specifically inform QRBrain.io when you stop using the Service. You acknowledge and agree that if QRBrain.io disables access to your account, you may be prevented from accessing the Service, your account details or any files or other materials which are contained in your account.',
        1: 'If we decide to change our Terms & Conditions, we will post those changes on this page, and/or update the Terms & Conditions modification date below.',
      },
      modify: {
        title: 'Modifications to Our website',
        0: 'QRBrain.io reserves the right to modify, suspend or discontinue, temporarily or permanently, the website or any service to which it connects, with or without notice and without liability to you.',
      },
      updates: {
        title: 'Updates to Our website',
        0: 'QRBrain.io may from time to time provide enhancements or improvements to the features/functionality of the website, which may include patches, bug fixes, updates, upgrades and other modifications ("Updates").',
        1: 'Updates may modify or delete certain features and/or functionalities of the website. You agree that QRBrain.io has no obligation to (i) provide any Updates, or (ii) continue to provide or enable any particular features and/or functionalities of the website to you.',
        2: 'You further agree that all Updates will be (i) deemed to constitute an integral part of the website, and (ii) subject to the terms and conditions of this Agreement.',
      },
      ownership: {
        title: 'Ownership of the end product',
        0: 'The data and IP from the codes you generate are owned by you.',
      },
      service: {
        title: 'Third-Party Services',
        0: 'We may display, include or make available third-party content (including data, information, applications and other products services) or provide links to third-party websites or services ("Third-Party Services").',
        1: 'You acknowledge and agree that QRBrain.io shall not be responsible for any Third-Party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. QRBrain.io does not assume and shall not have any liability or responsibility to you or any other person or entity for any Third-Party Services.',
        2: `Third-Party Services and links thereto are provided solely as a convenience to you and you access and use them entirely at your own risk and subject to such third parties' terms and conditions.`,
      },
      termination: {
        title: 'Term and Termination',
        0: 'This Agreement shall remain in effect until terminated by you or QRBrain.io.',
        1: 'QRBrain.io may, in its sole discretion, at any time and for any or no reason, suspend or terminate this Agreement with or without prior notice.',
        2: 'This Agreement will terminate immediately, without prior notice from QRBrain.io, in the event that you fail to comply with any provision of this Agreement. You may also terminate this Agreement by deleting the website and all copies thereof from your computer.',
        3: 'Upon termination of this Agreement, you shall cease all use of the website and delete all copies of the website from your computer.',
        4: `Termination of this Agreement will not limit any of QRBrain.io's rights or remedies at law or in equity in case of breach by you (during the term of this Agreement) of any of your obligations under the present Agreement.`,
      },
      copyright: {
        title: 'Copyright Infringement Notice',
        0: 'If you are a copyright owner or such owner’s agent and believe any material on our website constitutes an infringement on your copyright, please contact us setting forth the following information: (a) a physical or electronic signature of the copyright owner or a person authorized to act on his behalf; (b) identification of the material that is claimed to be infringing; (c) your contact information, including your address, telephone number, and an email; (d) a statement by you that you have a good faith belief that use of the material is not authorized by the copyright owners; and (e) a statement that the information in the notification is accurate, and, under penalty of perjury you are authorized to act on behalf of the owner.',
      },
      indemnification: {
        title: 'Indemnification',
        0: `You agree to indemnify and hold QRBrain.io and its parents, subsidiaries, affiliates, officers, employees, agents, partners and licensors (if any) harmless from any claim or demand, including reasonable attorneys' fees, due to or arising out of your: (a) use of the website; (b) violation of this Agreement or any law or regulation; or (c) violation of any right of a third party.`,
      },
      warranties: {
        title: 'No Warranties',
        0: 'The website is provided to you "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, QRBrain.io, on its own behalf and on behalf of its affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the website, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, QRBrain.io provides no warranty or undertaking, and makes no representation of any kind that the website will meet your requirements, achieve any intended results, be compatible or work with any other software, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.',
        1: `Without limiting the foregoing, neither QRBrain.io nor any of QRBrain.io's providers makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the website, or the information, content, and materials or products included thereon; (ii) that the website will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the website; or (iv) that the website, its servers, the content, or e-mails sent from or on behalf of QRBrain.io are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.`,
        2: 'Some jurisdictions do not allow the exclusion of or limitations on implied warranties or the limitations on the applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to you.',
      },
      limit: {
        title: 'Limitation of Liability',
        0: 'Notwithstanding any damages that you might incur, the entire liability of QRBrain.io and any of its suppliers under any provision of this Agreement and your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by you for the website.',
        1: 'To the maximum extent permitted by applicable law, in no event shall QRBrain.io or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, for loss of data or other information, for business interruption, for personal injury, for loss of privacy arising out of or in any way related to the use of or inability to use the website, third-party software and/or third-party hardware used with the website, or otherwise in connection with any provision of this Agreement), even if QRBrain.io or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.',
        2: 'Some states/jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitation or exclusion may not apply to you.',
      },
      sever: {
        title: 'Severability',
        0: 'If any provision of this Agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.',
        1: `This Agreement, together with the Privacy Policy and any other legal notices published by QRBrain.io on the Services, shall constitute the entire agreement between you and QRBrain.io concerning the Services. If any provision of this Agreement is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of this Agreement, which shall remain in full force and effect. No waiver of any term of this Agreement shall be deemed a further or continuing waiver of such term or any other term, and QRBrain.io's failure to assert any right or provision under this Agreement shall not constitute a waiver of such right or provision. YOU AND QRBrain.io AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.`,
      },
      waiver: {
        title: 'Waiver',
        0: `Except as provided herein, the failure to exercise a right or to require performance of an obligation under this Agreement shall not affect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute waiver of any subsequent breach.`,
        1: 'No failure to exercise, and no delay in exercising, on the part of either party, any right or any power under this Agreement shall operate as a waiver of that right or power. Nor shall any single or partial exercise of any right or power under this Agreement preclude further exercise of that or any other right granted herein. In the event of a conflict between this Agreement and any applicable purchase or other terms, the terms of this Agreement shall govern.',
      },
      amendments: {
        title: 'Amendments to this Agreement',
        0: `QRBrain.io reserves the right, at its sole discretion, to modify or replace this Agreement at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.`,
        1: 'By continuing to access or use our website after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use QRBrain.io.',
      },
      entire: {
        title: 'Entire Agreement',
        0: 'The Agreement constitutes the entire agreement between you and QRBrain.io regarding your use of the website and supersedes all prior and contemporaneous written or oral agreements between you and QRBrain.io.',
        1: `You may be subject to additional terms and conditions that apply when you use or purchase other QRBrain.io's services, which QRBrain.io will provide to you at the time of such use or purchase.`,
      },
      updatesTerm: {
        title: 'Updates to Our Terms',
        0: 'We may change our Service and policies, and we may need to make changes to these Terms so that they accurately reflect our Service and policies. Unless otherwise required by law, we will notify you (for example, through our Service) before we make changes to these Terms and give you an opportunity to review them before they go into effect. Then, if you continue to use the Service, you will be bound by the updated Terms. If you do not want to agree to these or any updated Terms, you can delete your account.',
      },
      intellectual: {
        title: 'Intellectual Property',
        0: 'The website and its entire contents, features and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection and arrangement thereof), are owned by QRBrain.io, its licensors or other providers of such material and are protected by AR and international copyright, trademark, patent, trade secret and other intellectual property or proprietary rights laws. The material may not be copied, modified, reproduced, downloaded or distributed in any way, in whole or in part, without the express prior written permission of QRBrain.io, unless and except as is expressly provided in these Terms & Conditions. Any unauthorized use of the material is prohibited.',
      },
      arbitrate: {
        title: 'Agreement to Arbitrate',
        0: 'This section applies to any dispute EXCEPT IT DOESN’T INCLUDE A DISPUTE RELATING TO CLAIMS FOR INJUNCTIVE OR EQUITABLE RELIEF REGARDING THE ENFORCEMENT OR VALIDITY OF YOUR OR QRBrain.io’s INTELLECTUAL PROPERTY RIGHTS. The term “dispute” means any dispute, action, or other controversy between you and QRBrain.io concerning the Services or this agreement, whether in contract, warranty, tort, statute, regulation, ordinance, or any other legal or equitable basis. “Dispute” will be given the broadest possible meaning allowable under law.',
      },
      dispute: {
        title: 'Notice of Dispute',
        0: 'In the event of a dispute, you or QRBrain.io must give the other a Notice of Dispute, which is a written statement that sets forth the name, address, and contact information of the party giving it, the facts giving rise to the dispute, and the relief requested. You must send any Notice of Dispute via email to: support@qrbrain.io. QRBrain.io will send any Notice of Dispute to you by mail to your address if we have it, or otherwise to your email address. You and QRBrain.io will attempt to resolve any dispute through informal negotiation within sixty (60) days from the date the Notice of Dispute is sent. After sixty (60) days, you or QRBrain.io may commence arbitration.',
      },
      bindArb: {
        title: 'Binding Arbitration',
        0: 'If you and QRBrain.io don’t resolve any dispute by informal negotiation, any other effort to resolve the dispute will be conducted exclusively by binding arbitration as described in this section. You are giving up the right to litigate (or participate in as a party or class member) all disputes in court before a judge or jury. The dispute shall be settled by binding arbitration in accordance with the commercial arbitration rules of the American Arbitration Association. Either party may seek any interim or preliminary injunctive relief from any court of competent jurisdiction, as necessary to protect the party’s rights or property pending the completion of arbitration. Any and all legal, accounting, and other costs, fees, and expenses incurred by the prevailing party shall be borne by the non-prevailing party.',
      },
      subprivacy: {
        title: 'Submissions and Privacy',
        0: 'In the event that you submit or post any ideas, creative suggestions, designs, photographs, information, advertisements, data or proposals, including ideas for new or improved products, services, features, technologies or promotions, you expressly agree that such submissions will automatically be treated as non-confidential and non-proprietary and will become the sole property of QRBrain.io without any compensation or credit to you whatsoever. QRBrain.io and its affiliates shall have no obligations with respect to such submissions or posts and may use the ideas contained in such submissions or posts for any purposes in any medium in perpetuity, including, but not limited to, developing, manufacturing, and marketing products and services using such ideas.',
      },
      promotions: {
        title: 'Promotions',
        0: 'QRBrain.io may, from time to time, include contests, promotions, sweepstakes, or other activities (“Promotions”) that require you to submit material or information concerning yourself. Please note that all Promotions may be governed by separate rules that may contain certain eligibility requirements, such as restrictions as to age and geographic location. You are responsible to read all Promotions rules to determine whether or not you are eligible to participate. If you enter any Promotion, you agree to abide by and to comply with all Promotions Rules.',
        1: 'Additional terms and conditions may apply to purchases of goods or services on or through the Services, which terms and conditions are made a part of this Agreement by this reference.',
      },
      typogrerror: {
        title: 'Typographical Errors',
        0: 'In the event a product and/or service is listed at an incorrect price or with incorrect information due to typographical error, we shall have the right to refuse or cancel any orders placed for the product and/or service listed at the incorrect price. We shall have the right to refuse or cancel any such order whether or not the order has been confirmed and your credit card charged. If your credit card has already been charged for the purchase and your order is canceled, we shall immediately issue a credit to your credit card account or other payment account in the amount of the charge.',
      },
      miscell: {
        title: 'Miscellaneous',
        0: 'If for any reason a court of competent jurisdiction finds any provision or portion of these Terms & Conditions to be unenforceable, the remainder of these Terms & Conditions will continue in full force and effect. Any waiver of any provision of these Terms & Conditions will be effective only if in writing and signed by an authorized representative of QRBrain.io. QRBrain.io will be entitled to injunctive or other equitable relief (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by you. QRBrain.io operates and controls the QRBrain.io Service from its offices in AR. The Service is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation. Accordingly, those persons who choose to access the QRBrain.io Service from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable. These Terms & Conditions (which include and incorporate the QRBrain.io Privacy Policy) contain the entire understanding, and supersedes all prior understandings, between you and QRBrain.io concerning its subject matter, and cannot be changed or modified by you. The section headings used in this Agreement are for convenience only and will not be given any legal import.',
      },
      disclaimer: {
        title: 'Disclaimer',
        0: 'QRBrain.io is not responsible for any content, code or any other imprecision.',
        1: 'QRBrain.io does not provide warranties or guarantees.',
        2: 'In no event shall QRBrain.io be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice.',
        3: 'The QRBrain.io Service and its contents are provided "as is" and "as available" without any warranty or representations of any kind, whether express or implied. QRBrain.io is a distributor and not a publisher of the content supplied by third parties; as such, QRBrain.io exercises no editorial control over such content and makes no warranty or representation as to the accuracy, reliability or currency of any information, content, service or merchandise provided through or accessible via the QRBrain.io Service. Without limiting the foregoing, QRBrain.io specifically disclaims all warranties and representations in any content transmitted on or in connection with the QRBrain.io Service or on sites that may appear as links on the QRBrain.io Service, or in the products provided as a part of, or otherwise in connection with, the QRBrain.io Service, including without limitation any warranties of merchantability, fitness for a particular purpose or non-infringement of third party rights. No oral advice or written information given by QRBrain.io or any of its affiliates, employees, officers, directors, agents, or the like will create a warranty. Price and availability information is subject to change without notice. Without limiting the foregoing, QRBrain.io does not warrant that the QRBrain.io Service will be uninterrupted, uncorrupted, timely, or error-free.',
      },
      contactus: {
        title: 'Contact Us',
        0: `Don't hesitate to contact us if you have any questions.`,
        1: 'Vía Email: ',
      },
    },
    dataDeletion: {
      deleteAccountTitle: 'Delete Account & Data',
      deleteAccountIntro:
        'We value your privacy and understand that you may want to delete your account and the associated data. This page outlines how you can delete your account and any data related to your usage of our service, including data retrieved via third-party login services like Facebook.',
      deletingAccount: {
        title: 'Deleting Your Account',
        title2: 'If you wish to delete your account, please follow these steps:',
        step1: 'Login to Your Account:',
        step1Desc:
          'Visit our website and log in using your account credentials or via a third-party login provider, such as Facebook.',
        step2: 'Navigate to Account Settings:',
        step2Desc: 'After logging in, click on the settings icon at the top right corner of the screen.',
        step3: 'Request Account Deletion:',
        step3Desc:
          "In the Account Settings section, scroll down to the Account details area. Click on 'Delete Account', and follow the prompts to confirm the deletion.",
        finalNote:
          'Once the deletion process is initiated, your account and associated data will be permanently removed from our servers within 7 days.',
      },
      deletingDataViaFacebook: {
        title: 'Deleting Data via Facebook Login',
        title2:
          'If you signed up using your Facebook account, you can also delete the data associated with our app through Facebook directly.',
        step1: 'Log in to Facebook:',
        step1Desc: 'Go to Facebook and log in to your account.',
        step2: 'Access Your Apps and Websites Settings:',
        step2Desc:
          "Click the down arrow at the top-right of Facebook and select 'Settings & Privacy', then go to 'Settings'.",
        step3Desc: "In the left sidebar, select 'Apps and Websites'.",
        step3: 'Remove Our App:',
        step4Desc: 'Find our app in the Active section.',
        step5Desc: "Click 'Remove' to delete our app’s access to your Facebook account data.",
        finalNote:
          'Removing our app from Facebook will prevent any further data sharing between Facebook and our platform, but you may still need to delete your account on our platform using the steps mentioned above.',
      },
      requestingDataDeletionManually: {
        title: 'Requesting Data Deletion Manually',
        descriptionPart1:
          'If you encounter any issues with the above steps or prefer manual assistance, you can contact our support team by emailing',
        descriptionLink: 'support@qrbrain.io',
        descriptionPart2: " with the subject line 'Account Deletion Request'.",
        step1: 'Your full name',
        step2: 'Your email address (or Facebook account associated with your login)',
        step3: 'Any other relevant information that can help us identify your account.',
        finalNote:
          'We will process your request within 30 days and confirm once your data has been permanently deleted.',
      },
      dataDeletion: {
        contactUsPart1:
          'If you have any other questions about managing or deleting your data, feel free to reach out to us at',
        contactUsLink: 'support@qrbrain.io',
        contactUsPart2: '.',
      },
    },
    common: {
      language: 'Language',
      createQrCodes: 'Create QR Codes',
      createQrCode: 'Create QR Code',
      services: 'Services',
      listOfLinks: 'List of Links',
      vCardPlus: 'vCard Plus',
      vCard: 'vCard',
      showMore: 'Show More',
      faq: {
        title: 'FAQ',
        qrGeneration: {
          title: 'What does QR generation mean?',
          description:
            'It is a tool that enables you to easily and intuitively create various types of QR codes. With the increasing popularity of QR codes, our generator has become a go-to resource for individuals and businesses alike. It can be used by businesses of all kinds to create QR codes for websites, share PDFs, photo galleries, playlists, price lists or menus, connect customers with services offered by your business (such as WiFi access, appointments, payments, etc.), promote events with links to trailers, create vCards with contact information to share with clients, and much more',
        },
        createAccount: {
          title: 'Can I create an account to generate QR codes for free?',
          description:
            'Absolutely, the first seven days are on us, allowing you to try our QR code generator for free.',
        },
        freeAvailable: {
          title: 'Are QR codes available for free?',
          description:
            "Our QR code generator offers a seven-day free trial, allowing you to create and keep QR codes permanently. If you’re happy with the service, you can choose a plan that fits your needs. With a subscription, you'll gain unlimited access to all features: create unlimited dynamic and editable QR codes, explore various QR types, manage and edit your QRs, track unlimited scans, view comprehensive analytics, and download in multiple formats.\n",
        },
      },
      someDescription: 'Some description',
      uploadFileFailed: 'Upload failed, too large files',
      startTypingHere: 'Start typing here',
      telephone: 'Telephone',
      eg: 'E.g.',
      personalWebsite: 'Personal website',
      typeHere: 'Type here...',
      enterName: 'Enter your name here...',
      enterSurname: 'Enter your surname here...',
      enterCompanyName: 'Enter your company name here...',
      enterTitleName: 'Enter your title name here...',
      enterDescription: 'Enter your description here...',
      uploadPDF: 'Upload PDF(s)',
      maxSize: 'Max size',
      writeLinkText: 'Write here the link text...',
      enterAppName: 'Enter App name here...',
      writeButtonText: 'Write the button text here...',
      color: 'Color',
      youTubeError: 'The URL must be a valid link to a YouTube video (format: youtube.com/watch?v=...)',
      actions: 'Actions',
    },
    contactUs: {
      title: 'Contact us',
      nameSurname: 'Name and surname *',
      nameSurnameEg: 'E.g. Paul Jones',
      email: 'Email address *',
      emailEg: 'E.g. name@email.com',
      subject: 'Subject *',
      question: 'Question/Enquiry *',
      questionEg: 'E.g. Lorem ipsum',
      send: 'Send',
      subjectPlaceholder: 'Subject...',
    },
    qrTable: {
      scanLimit: 'Scan Limit',
      untitled: 'Untitled',
      noFolder: 'No Folder',
      notCreated: 'You have not created any QR codes yet. All the QR codes you create will be displayed on this page.',
      draft: 'Draft',
    },
    builder: {
      qrType: 'QR Type',
      linkToWebsite: 'Link to website URL',
      showPDFFile: 'Show PDF file',
      shareLinks: 'Share links',
      shareDifferentImage: 'Share different images',
      yourSocialChannels: 'Your social channels',
      digitalBusinessCard: 'Digital business card',
      change: 'Change',
      video: {
        video: {
          title: 'Video',
          videoUrl: 'Video URL',
          addVideo: 'Add Video',
          uploadVideo: 'Upload Video(s)',
          showDirectly: 'Show video directly',
        },
        information: {
          title: 'Information',
          videoTitle: 'Video title',
          addButton: 'Add Button',
          buttonText: 'Button text',
          buttonUrl: 'URL',
        },
      },
      coupon: {
        offer: {
          title: 'Offer Information',
          salesBadge: 'Sales badge',
          codeButton: 'Button to see the code',
          companyPlaceholder: 'E.g. John’s Super Burgers',
          titlePlaceholder: 'E.g. Best Burgers in town',
          salesBadgePlaceholder: 'E.g. 10% Off',
          codeButtonPlaceholder: 'E.g. Get Coupon',
        },
        coupon: {
          useBarcode: 'Use barcode',
          barcodeTitle: 'Barcode (640 x 360px)',
          title: 'Coupon Information',
          code: 'Coupon code',
          validUntil: 'Valid until',
          terms: 'Terms and Conditions',
          codePlaceholder: 'E.g. SALE25',
          termsPlaceholder: 'Provide the terms & conditions of your coupon',
          seeLocation: 'See Location',
          copyCode: 'Copy Code',
          termsWithCond: 'Terms & Conditions',
        },
      },
      designStep: {
        frame: {
          description: 'Design an outer frame to make your QR stand out.',
          frameText: 'Frame Text',
          frameBg: 'Frame Background color',
          fontStyle: 'Font style',
        },
        pattern: {
          title: 'Pattern',
          description: 'Customize the QR modules (dots/squares that make up the code).',
          patternColor: 'Pattern Color',
        },
        cornerStyle: {
          title: 'Corner Style',
          description: "Style the QR's corner frames and dots.",
          cornerFrame: {
            title: 'Corner frame',
            cornerFrameStyle: 'Frame around corner dots style',
            cornerFrameColor: 'Frame around corner dots color',
          },
          cornerDots: 'Corner dots',
          cornerDotsColor: 'Corner dots color',
        },
        errorCorrectionLevel: {
          description:
            'Ensures reliable reading by compensating for damage or distortion. Choosing a higher level improves readability, although it may increase the size of the QR.',
          infoText: 'Higher levels increase scan reliability but result in a denser QR code.',
        },
        logo: {
          title: 'Logo',
          description: 'Embed a logo in the middle of your QR code.',
        },
      },
      testScan: {
        title: 'Test Scan',
        testCode: 'Test your QR Code',
        description: "Use your phone's camera to scan this QR code and see how it functions.",
        howToTest: {
          title: 'How to test:',
          step1: 'Launch your smartphone’s camera app',
          step2: 'Aim it at the QR code',
          step3: 'When a prompt appears, tap on it',
          step4: 'You’ll be taken directly to the linked content',
        },
      },
      nameAndFolder: {
        folder: 'Folder',
        noFolder: 'No Folder',
        createFolder: 'Create Folder',
        createNewFolder: 'Create New Folder',
      },
    },
    folders: {
      myFolders: 'My Folders',
      editFolderName: 'Edit folder name',
      changeFolderName: 'Change Folder Name',
      downloadQRs: 'Download QRs',
      deleteFolder: 'Delete folder',
      searchFolder: 'Search folder...',
      sortBy: 'Sort by',
      mostRecent: 'Most recent',
      oldest: 'Oldest',
      selectOrCreateFolder: 'Select a folder or create a new one',
      selectFolderDescription:
        'The chosen QR codes will be delivered to your selected folder. You can assist with the search function.',
      emptyFolders: 'You don’t have any folders yet...',
      deleteFolderQuestion: 'Are you sure you want to delete this folder?',
      noResults: 'No results found...',
      noQRsInFolder: 'You don’t have any QR codes in this folder.',
    },
  },
} as const;
